import { ref as I, defineComponent as Q, inject as V, computed as z, withDirectives as Le, openBlock as v, createElementBlock as x, normalizeClass as X, createBlock as W, resolveDynamicComponent as ie, withCtx as le, createElementVNode as w, unref as L, createCommentVNode as N, Fragment as re, renderList as fe, createVNode as R, createTextVNode as Ce, toDisplayString as Z, nextTick as Ie, watch as K, onMounted as pe, onUnmounted as nt, normalizeStyle as Ln, useCssVars as Cn, vModelText as Pn, normalizeProps as En, guardReactiveProps as On, provide as te, KeepAlive as Sn, vShow as Tt, renderSlot as on, onBeforeUnmount as Dn, createSlots as $n } from "vue";
import { useDebounceFn as Bn, onClickOutside as An, useIntervalFn as Mn, useSwipe as sn } from "@vueuse/core";
import { $ as Ze } from "./FrontiersClibConfigService.5b50b8d0.js";
import '../assets/Card.css';import '../assets/index20.css';/* empty css                                               */import { _ as Lt } from "./FrontiersImage.vue_vue_type_script_setup_true_lang.2836b6c7.js";
import { a as an, _ as Vn } from "./CardMetricList.vue_vue_type_script_setup_true_lang.a398feed.js";
import { Avatar as Fn } from "../avatar.es.js";
import dt, { gsap as H } from "gsap";
import { _ as zn } from "./Card.vue_vue_type_script_setup_true_lang.d829b19e.js";
import { ScrollTrigger as Be } from "gsap/ScrollTrigger";
import { FullScreenIcon as Ht, ArrowRightIcon as Nn, ImageIcon as Rn, LessIcon as Wn, MoreCircledIcon as jn, DownloadIcon as ln, CloseIcon as Yn, ChevronDownIcon as Hn } from "@frontiers/brink-icons";
import { B as rn, g as Ct, a as un, b as Fe, c as Un, d as Ut, v as Xn } from "./BodyScrollLock.f247d772.js";
import { ButtonIcon as Ae } from "../buttonIcon.es.js";
import Jn from "@panzoom/panzoom";
import { _ as qn } from "./_plugin-vue_export-helper.dad06003.js";
import { OnClickOutside as cn } from "@vueuse/components";
class Gn {
  static isInternetExplorer() {
    return !!window.MSInputMethodContext && !!document.documentMode;
  }
  static isMsEdge() {
    return navigator.appVersion.indexOf("Edge") != -1;
  }
  static isFirefox() {
    return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
  }
}
function Zn(a) {
  const e = [], n = /* @__PURE__ */ new Map();
  return a.forEach((o) => {
    var i;
    (i = o.affiliations) == null || i.forEach((s) => {
      const u = JSON.stringify(s);
      if (!n.has(u)) {
        const l = e.length + 1, r = Object.values(s).filter((c) => c).join(", ");
        e.push({
          ...s,
          affiliations: r,
          index: l
        }), n.set(u, l);
      }
    });
  }), {
    people: a.map((o) => {
      var s;
      const i = ((s = o.affiliations) == null ? void 0 : s.map((u) => {
        const l = JSON.stringify(u);
        return n.get(l);
      })) || [];
      return { ...o, affiliationIndexes: i };
    }),
    organizations: e
  };
}
const qe = [
  "bottomcenter",
  "bottomleft",
  "leftbottom",
  "leftcenter",
  "lefttop",
  "topleft",
  "topcenter",
  "topright",
  "righttop",
  "rightcenter",
  "rightbottom",
  "bottomright"
], Kn = ["top", "right", "left", "bottom"], Qn = [
  "center",
  "top",
  "right",
  "left",
  "bottom"
], ei = (a) => {
  const e = qe.indexOf(a);
  return qe[e + 1] || qe[0];
}, ti = (a) => qe.includes(a), ni = (a, e) => {
  const n = window.innerWidth;
  let t = e;
  const o = [
    { max: 563, attribute: "po:mobile" },
    { min: 564, max: 768, attribute: "po:tablet-portrait" },
    { min: 769, max: 1024, attribute: "po:tablet-landscape" },
    { min: 1025, max: 1280, attribute: "po:laptop-small" },
    { min: 1281, max: 1440, attribute: "po:laptop" },
    { min: 1441, attribute: "po:desktop" }
  ];
  for (const { min: i = -1 / 0, max: s = 1 / 0, attribute: u } of o)
    if (n >= i && n < s) {
      const l = a.getAttribute(u);
      l && (ti(l || "") ? t = l : console.warn(
        `[directive:popover] the position "${l}" defined for the breakpoint ${u}, is not valid, modifier position or default position will be used.)`
      ));
    }
  return t;
}, Ke = (a, e) => {
  var u;
  const n = a.modifiers;
  let t = ((u = a.value) == null ? void 0 : u.position) || "bottomcenter", o = "click";
  const i = Object.keys(n).filter((l) => {
    if (l !== "click" && l !== "hover")
      return l;
  }), s = Object.keys(n).filter((l) => {
    if (l === "click" || l === "hover")
      return l;
  });
  return i.length >= 1 && (t = i[0]), s.length >= 1 && (o = s[0]), {
    modifiersPosition: i,
    modifiersAction: s,
    modifierPosition: ni(e, t),
    modifierAction: o
  };
}, Pt = (a) => {
  let e = "bottom", n = "center";
  for (const t of Kn)
    a.startsWith(t) && (e = t);
  for (const t of Qn)
    a.endsWith(t) && (n = t);
  return {
    placement: e,
    alignment: n
  };
}, ii = (a, e) => {
  const { modifiersPosition: n, modifiersAction: t } = Ke(a, e);
  n.length > 1 && console.warn(
    `[directive:popover] there are more than one modifiers for position, only the first one will be used (${n})`
  ), t.length > 1 && console.warn(
    `[directive:popover] there are more than one modifiers for action, only the first one will be used (${n})`
  );
}, dn = (a, e, n) => {
  if (!n)
    return;
  const { placement: t, alignment: o } = Pt(e), i = a.getBoundingClientRect(), s = window.scrollY;
  if (t === "top" && (n.style.top = `${i.top + s}px`), t === "bottom" && (n.style.top = `${i.top + s + i.height}px`), t === "top" || t === "bottom")
    if (Math.min(window.innerWidth, screen.width) < 400) {
      const l = n.querySelector(".Popover__arrow"), r = Math.min(window.innerWidth, screen.width) / 2 - n.offsetWidth / 2, c = i.left + i.width / 2 - r;
      n.style.left = `${r}px`, l.style.left = `${c}px`, l.style.right = "auto";
    } else
      o === "center" && (n.style.left = `${i.left + i.width / 2}px`), o === "left" && (n.style.left = `${i.left}px`), o === "right" && (n.style.left = `${i.right}px`);
  t === "left" && (n.style.left = `${i.left}px`), t === "right" && (n.style.left = `${i.left + i.width}px`), (t === "left" || t === "right") && (o === "center" && (n.style.top = `${i.top + s + i.height / 2}px`), o === "top" && (n.style.top = `${i.top + s}px`), o === "bottom" && (n.style.top = `${i.bottom + s}px`));
}, Et = Bn((a) => {
  xe(a);
}, 150), oi = (a) => {
  a.classList.value = "Popover";
  const e = a.querySelector(".Popover__arrow");
  e.classList.value = "Popover__arrow", a.style.cssText = "", e.style.cssText = "";
}, fn = (a, e, n, t) => {
  const o = e.getBoundingClientRect();
  if (!(o.top >= 56 && o.left >= 2 && o.bottom <= Math.min(window.innerHeight, screen.height) - 2 && o.right <= Math.min(window.innerWidth, screen.width) - 17)) {
    oi(e);
    const s = ei(n), { placement: u, alignment: l } = Pt(s);
    e.classList.add(
      "Popover",
      `Popover--${u}`,
      `Popover--a${l}`
    ), e.querySelector(".Popover__arrow").classList.add(`Popover__arrow--${s}`), dn(a, s, e), fn(a, e, s);
  }
}, wt = (a, e) => {
  const n = a;
  if (n.isVisible = !0, !e.value || e.value.message.length === 0)
    return;
  const t = document.createElement("div"), o = document.querySelector("body"), { modifierPosition: i } = Ke(e, a), { placement: s, alignment: u } = Pt(i);
  t.classList.add(
    "Popover",
    `Popover--${s}`,
    `Popover--a${u}`
  );
  const l = `
    <div class="Popover__arrow Popover__arrow--${i}"></div>
    <button class="Popover__close" aria-label="Close the popover"></button>
    <div class="Popover__content">
      ${e.value.message}
    </div>
  `;
  t.innerHTML = l, o.appendChild(t), n.popoverEl = t, dn(a, i, t), fn(a, t, i);
  const r = I(t);
  An(r, (d) => {
    const g = d.target;
    g === a || a.contains(g) || xe(a);
  }), t.querySelector(".Popover__close").addEventListener("click", () => {
    xe(a);
  }), window.addEventListener("resize", () => {
    Et(a);
  });
}, xe = (a) => {
  const e = a;
  e.isVisible = !1, e.popoverEl && (window.removeEventListener("resize", () => {
    Et(a);
  }), e.popoverEl.remove(), e.popoverEl = null);
}, Xt = (a, e) => {
  a.isVisible ? xe(a) : wt(a, e);
}, si = {
  mounted(a, e) {
    const n = a;
    n.isVisible = !1, typeof e.value == "string" && (e.value = { message: e.value }), ii(e, a);
    const { modifierAction: t } = Ke(e, a);
    t === "click" && a.addEventListener("click", () => {
      Xt(a, e);
    }), t === "hover" && (a.addEventListener("mouseover", () => {
      wt(a, e);
    }), a.addEventListener("mouseleave", () => {
      xe(a);
    }));
  },
  unmounted(a, e) {
    const { modifierAction: n } = Ke(e, a);
    n === "click" && a.removeEventListener("click", () => {
      Xt(a, e);
    }), n === "hover" && (a.removeEventListener("mouseover", () => {
      wt(a, e.value);
    }), a.removeEventListener("mouseleave", () => {
      xe(a);
    })), xe(a), window.removeEventListener("resize", () => {
      Et(a);
    });
  }
}, ai = /* @__PURE__ */ w("div", { class: "CardJournal__Header" }, "Published in", -1), li = { class: "CardJournal__ImgWrapper" }, ri = /* @__PURE__ */ w("div", { class: "CardJournal__ImgBorder" }, null, -1), ui = { class: "CardJournal__Body" }, ci = ["innerHTML"], di = {
  key: 0,
  class: "CardJournal__offlineTag"
}, fi = { class: "CardJournal__sections" }, pi = {
  key: 0,
  class: "CardJournal__offlineTag"
}, hi = {
  key: 0,
  class: "CardJournal__Footer"
}, Is = /* @__PURE__ */ Q({
  __name: "CardJournal",
  props: {
    journal: {},
    sections: { default: () => [] },
    heading: { default: "h3" },
    sectionHeading: { default: "h4" },
    popover: {}
  },
  setup(a) {
    const e = a, n = V("sanitize"), t = z(() => {
      const l = [];
      return e.journal.impactFactor && l.push({ value: e.journal.impactFactor, text: "impact factor" }), e.journal.citeScore && l.push({
        value: Number(e.journal.citeScore).toFixed(1),
        text: "citescore"
      }), l;
    }), o = z(() => t.value.length > 0), i = z(() => e.sections.find((l) => l.isOnline)), s = z(() => {
      let l = `https://www.${Ze.getMainDomain}/journals/${e.journal.slug}`;
      return !e.journal.isOnline && i.value && (l = `https://www.${Ze.getMainDomain}/journals/${e.journal.slug}/sections/${i.value.slug}`), { text: "Image text", url: l, ariaLabel: "Go to section page" };
    }), u = z(() => !e.journal.isOnline && !i.value);
    return (l, r) => Le((v(), x("article", {
      class: X(["CardJournal", {
        "CardJournal--disabled": u.value
      }])
    }, [
      (v(), W(ie(u.value ? "div" : "a"), {
        class: "CardJournal__Link",
        href: u.value ? "" : s.value.url,
        "aria-label": s.value.ariaLabel,
        "data-event": l.$ga.getDataEventValue("CardJournal", "a"),
        target: "_blank"
      }, {
        default: le(() => [
          ai,
          w("div", li, [
            l.journal.image ? (v(), W(L(Lt), {
              key: 0,
              class: "CardJournal__Img",
              sources: l.journal.image.sources,
              imageAlt: l.journal.image.imageAlt
            }, null, 8, ["sources", "imageAlt"])) : N("", !0),
            ri
          ]),
          w("div", ui, [
            (v(), W(ie(l.heading), { class: "CardJournal__Title CardJournal__Title--journal" }, {
              default: le(() => [
                w("span", {
                  innerHTML: L(n)(l.journal.name) + " "
                }, null, 8, ci),
                l.journal.isOnline ? N("", !0) : (v(), x("span", di, " Offline "))
              ]),
              _: 1
            })),
            w("ul", fi, [
              (v(!0), x(re, null, fe(l.sections, (c) => (v(), x("li", {
                class: "CardJournal__Title CardJournal__Title--section",
                key: c.id
              }, [
                (v(), W(ie(l.sectionHeading), {
                  class: "sectionTitle",
                  innerHTML: L(n)(c.name)
                }, null, 8, ["innerHTML"])),
                c.isOnline ? N("", !0) : (v(), x("span", pi, "Offline"))
              ]))), 128))
            ])
          ]),
          o.value ? (v(), x("div", hi, [
            R(L(an), { metrics: t.value }, null, 8, ["metrics"])
          ])) : N("", !0)
        ]),
        _: 1
      }, 8, ["href", "aria-label", "data-event"]))
    ], 2)), [
      [
        L(si),
        e.popover,
        void 0,
        { click: !0 }
      ]
    ]);
  }
}), vi = { class: "PeopleListItem__name notranslate" }, gi = { key: 0 }, mi = { key: 1 }, _i = { key: 2 }, Jt = /* @__PURE__ */ Q({
  __name: "PeopleListItem",
  props: {
    fullName: {},
    affiliationIndexes: {},
    userId: {},
    symbols: {},
    showIndexes: { type: Boolean },
    onBehalfOf: {}
  },
  setup(a) {
    const e = a, n = z(() => e.affiliationIndexes.join(",")), t = z(() => e.userId && e.userId > 0 ? `${Ze.getLoopUrl}/images/profile/${e.userId}/74` : ""), o = z(() => e.userId && e.userId > 0 ? `${Ze.getLoopUrl}/people/${e.userId}` : ""), i = z(() => e.userId && e.userId > 0 ? "a" : "div");
    return (s, u) => (v(), W(ie(i.value), {
      class: "PeopleListItem",
      href: o.value,
      "data-event": i.value === "a" ? s.$ga.getDataEventValue("PeopleListItem", "a") : null
    }, {
      default: le(() => [
        R(L(Fn), {
          class: "PeopleListItem__Avatar",
          "full-name": s.fullName,
          src: t.value,
          color: "Grey",
          size: "Size40"
        }, null, 8, ["full-name", "src"]),
        w("p", vi, [
          Ce(Z(s.fullName) + " ", 1),
          s.showIndexes ? (v(), x("sup", gi, Z(n.value), 1)) : N("", !0),
          s.onBehalfOf ? (v(), x("span", mi, Z(s.onBehalfOf), 1)) : N("", !0),
          s.symbols ? (v(), x("sup", _i, Z(s.symbols), 1)) : N("", !0)
        ])
      ]),
      _: 1
    }, 8, ["href", "data-event"]));
  }
});
/*!
 * matrix 3.12.0
 * https://greensock.com
 *
 * Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var me, Te, Ot, Me, Re, Ge, Qe, We, ae = "transform", yt = ae + "Origin", pn, St = function(e) {
  var n = e.ownerDocument || e;
  for (!(ae in e.style) && ("msTransform" in e.style) && (ae = "msTransform", yt = ae + "Origin"); n.parentNode && (n = n.parentNode); )
    ;
  if (Te = window, Qe = new Pe(), n) {
    me = n, Ot = n.documentElement, Me = n.body, We = me.createElementNS("http://www.w3.org/2000/svg", "g"), We.style.transform = "none";
    var t = n.createElement("div"), o = n.createElement("div");
    Me.appendChild(t), t.appendChild(o), t.style.position = "static", t.style[ae] = "translate3d(0,0,1px)", pn = o.offsetParent !== t, Me.removeChild(t);
  }
  return n;
}, bi = function(e) {
  for (var n, t; e && e !== Me; )
    t = e._gsap, t && t.uncache && t.get(e, "x"), t && !t.scaleX && !t.scaleY && t.renderTransform && (t.scaleX = t.scaleY = 1e-4, t.renderTransform(1, t), n ? n.push(t) : n = [t]), e = e.parentNode;
  return n;
}, hn = [], vn = [], Dt = function() {
  return Te.pageYOffset || me.scrollTop || Ot.scrollTop || Me.scrollTop || 0;
}, $t = function() {
  return Te.pageXOffset || me.scrollLeft || Ot.scrollLeft || Me.scrollLeft || 0;
}, Bt = function(e) {
  return e.ownerSVGElement || ((e.tagName + "").toLowerCase() === "svg" ? e : null);
}, wi = function a(e) {
  if (Te.getComputedStyle(e).position === "fixed")
    return !0;
  if (e = e.parentNode, e && e.nodeType === 1)
    return a(e);
}, ft = function a(e, n) {
  if (e.parentNode && (me || St(e))) {
    var t = Bt(e), o = t ? t.getAttribute("xmlns") || "http://www.w3.org/2000/svg" : "http://www.w3.org/1999/xhtml", i = t ? n ? "rect" : "g" : "div", s = n !== 2 ? 0 : 100, u = n === 3 ? 100 : 0, l = "position:absolute;display:block;pointer-events:none;margin:0;padding:0;", r = me.createElementNS ? me.createElementNS(o.replace(/^https/, "http"), i) : me.createElement(i);
    return n && (t ? (Ge || (Ge = a(e)), r.setAttribute("width", 0.01), r.setAttribute("height", 0.01), r.setAttribute("transform", "translate(" + s + "," + u + ")"), Ge.appendChild(r)) : (Re || (Re = a(e), Re.style.cssText = l), r.style.cssText = l + "width:0.1px;height:0.1px;top:" + u + "px;left:" + s + "px", Re.appendChild(r))), r;
  }
  throw "Need document and parent.";
}, yi = function(e) {
  for (var n = new Pe(), t = 0; t < e.numberOfItems; t++)
    n.multiply(e.getItem(t).matrix);
  return n;
}, gn = function(e) {
  var n = e.getCTM(), t;
  return n || (t = e.style[ae], e.style[ae] = "none", e.appendChild(We), n = We.getCTM(), e.removeChild(We), t ? e.style[ae] = t : e.style.removeProperty(ae.replace(/([A-Z])/g, "-$1").toLowerCase())), n || Qe.clone();
}, Ii = function(e, n) {
  var t = Bt(e), o = e === t, i = t ? hn : vn, s = e.parentNode, u, l, r, c, d, g;
  if (e === Te)
    return e;
  if (i.length || i.push(ft(e, 1), ft(e, 2), ft(e, 3)), u = t ? Ge : Re, t)
    o ? (r = gn(e), c = -r.e / r.a, d = -r.f / r.d, l = Qe) : e.getBBox ? (r = e.getBBox(), l = e.transform ? e.transform.baseVal : {}, l = l.numberOfItems ? l.numberOfItems > 1 ? yi(l) : l.getItem(0).matrix : Qe, c = l.a * r.x + l.c * r.y, d = l.b * r.x + l.d * r.y) : (l = new Pe(), c = d = 0), n && e.tagName.toLowerCase() === "g" && (c = d = 0), (o ? t : s).appendChild(u), u.setAttribute("transform", "matrix(" + l.a + "," + l.b + "," + l.c + "," + l.d + "," + (l.e + c) + "," + (l.f + d) + ")");
  else {
    if (c = d = 0, pn)
      for (l = e.offsetParent, r = e; r && (r = r.parentNode) && r !== l && r.parentNode; )
        (Te.getComputedStyle(r)[ae] + "").length > 4 && (c = r.offsetLeft, d = r.offsetTop, r = 0);
    if (g = Te.getComputedStyle(e), g.position !== "absolute" && g.position !== "fixed")
      for (l = e.offsetParent; s && s !== l; )
        c += s.scrollLeft || 0, d += s.scrollTop || 0, s = s.parentNode;
    r = u.style, r.top = e.offsetTop - d + "px", r.left = e.offsetLeft - c + "px", r[ae] = g[ae], r[yt] = g[yt], r.position = g.position === "fixed" ? "fixed" : "absolute", e.parentNode.appendChild(u);
  }
  return u;
}, pt = function(e, n, t, o, i, s, u) {
  return e.a = n, e.b = t, e.c = o, e.d = i, e.e = s, e.f = u, e;
}, Pe = /* @__PURE__ */ function() {
  function a(n, t, o, i, s, u) {
    n === void 0 && (n = 1), t === void 0 && (t = 0), o === void 0 && (o = 0), i === void 0 && (i = 1), s === void 0 && (s = 0), u === void 0 && (u = 0), pt(this, n, t, o, i, s, u);
  }
  var e = a.prototype;
  return e.inverse = function() {
    var t = this.a, o = this.b, i = this.c, s = this.d, u = this.e, l = this.f, r = t * s - o * i || 1e-10;
    return pt(this, s / r, -o / r, -i / r, t / r, (i * l - s * u) / r, -(t * l - o * u) / r);
  }, e.multiply = function(t) {
    var o = this.a, i = this.b, s = this.c, u = this.d, l = this.e, r = this.f, c = t.a, d = t.c, g = t.b, h = t.d, p = t.e, O = t.f;
    return pt(this, c * o + g * s, c * i + g * u, d * o + h * s, d * i + h * u, l + p * o + O * s, r + p * i + O * u);
  }, e.clone = function() {
    return new a(this.a, this.b, this.c, this.d, this.e, this.f);
  }, e.equals = function(t) {
    var o = this.a, i = this.b, s = this.c, u = this.d, l = this.e, r = this.f;
    return o === t.a && i === t.b && s === t.c && u === t.d && l === t.e && r === t.f;
  }, e.apply = function(t, o) {
    o === void 0 && (o = {});
    var i = t.x, s = t.y, u = this.a, l = this.b, r = this.c, c = this.d, d = this.e, g = this.f;
    return o.x = i * u + s * r + d || 0, o.y = i * l + s * c + g || 0, o;
  }, a;
}();
function de(a, e, n, t) {
  if (!a || !a.parentNode || (me || St(a)).documentElement === a)
    return new Pe();
  var o = bi(a), i = Bt(a), s = i ? hn : vn, u = Ii(a, n), l = s[0].getBoundingClientRect(), r = s[1].getBoundingClientRect(), c = s[2].getBoundingClientRect(), d = u.parentNode, g = !t && wi(a), h = new Pe((r.left - l.left) / 100, (r.top - l.top) / 100, (c.left - l.left) / 100, (c.top - l.top) / 100, l.left + (g ? 0 : $t()), l.top + (g ? 0 : Dt()));
  if (d.removeChild(u), o)
    for (l = o.length; l--; )
      r = o[l], r.scaleX = r.scaleY = 0, r.renderTransform(1, r);
  return e ? h.inverse() : h;
}
/*!
 * Flip 3.12.0
 * https://greensock.com
 *
 * @license Copyright 2008-2023, GreenSock. All rights reserved.
 * Subject to the terms at https://greensock.com/standard-license or for
 * Club GreenSock members, the agreement issued with that membership.
 * @author: Jack Doyle, jack@greensock.com
*/
var ki = 1, ze, ne, j, je, ye, _e, It, qt = function(e, n) {
  return e.actions.forEach(function(t) {
    return t.vars[n] && t.vars[n](t);
  });
}, kt = {}, Gt = 180 / Math.PI, xi = Math.PI / 180, et = {}, Zt = {}, it = {}, At = function(e) {
  return typeof e == "string" ? e.split(" ").join("").split(",") : e;
}, Ti = At("onStart,onUpdate,onComplete,onReverseComplete,onInterrupt"), ot = At("transform,transformOrigin,width,height,position,top,left,opacity,zIndex,maxWidth,maxHeight,minWidth,minHeight"), Ye = function(e) {
  return ze(e)[0] || console.warn("Element not found:", e);
}, De = function(e) {
  return Math.round(e * 1e4) / 1e4 || 0;
}, ht = function(e, n, t) {
  return e.forEach(function(o) {
    return o.classList[t](n);
  });
}, Kt = {
  zIndex: 1,
  kill: 1,
  simple: 1,
  spin: 1,
  clearProps: 1,
  targets: 1,
  toggleClass: 1,
  onComplete: 1,
  onUpdate: 1,
  onInterrupt: 1,
  onStart: 1,
  delay: 1,
  repeat: 1,
  repeatDelay: 1,
  yoyo: 1,
  scale: 1,
  fade: 1,
  absolute: 1,
  props: 1,
  onEnter: 1,
  onLeave: 1,
  custom: 1,
  paused: 1,
  nested: 1,
  prune: 1,
  absoluteOnLeave: 1
}, mn = {
  zIndex: 1,
  simple: 1,
  clearProps: 1,
  scale: 1,
  absolute: 1,
  fitChild: 1,
  getVars: 1,
  props: 1
}, _n = function(e) {
  return e.replace(/([A-Z])/g, "-$1").toLowerCase();
}, $e = function(e, n) {
  var t = {}, o;
  for (o in e)
    n[o] || (t[o] = e[o]);
  return t;
}, Mt = {}, bn = function(e) {
  var n = Mt[e] = At(e);
  return it[e] = n.concat(ot), n;
}, Li = function(e) {
  var n = e._gsap || ne.core.getCache(e);
  return n.gmCache === ne.ticker.frame ? n.gMatrix : (n.gmCache = ne.ticker.frame, n.gMatrix = de(e, !0, !1, !0));
}, Ci = function a(e, n, t) {
  t === void 0 && (t = 0);
  for (var o = e.parentNode, i = 1e3 * Math.pow(10, t) * (n ? -1 : 1), s = n ? -i * 900 : 0; e; )
    s += i, e = e.previousSibling;
  return o ? s + a(o, n, t + 1) : s;
}, tt = function(e, n, t) {
  return e.forEach(function(o) {
    return o.d = Ci(t ? o.element : o.t, n);
  }), e.sort(function(o, i) {
    return o.d - i.d;
  }), e;
}, He = function(e, n) {
  for (var t = e.element.style, o = e.css = e.css || [], i = n.length, s, u; i--; )
    s = n[i], u = t[s] || t.getPropertyValue(s), o.push(u ? s : Zt[s] || (Zt[s] = _n(s)), u);
  return t;
}, Vt = function(e) {
  var n = e.css, t = e.element.style, o = 0;
  for (e.cache.uncache = 1; o < n.length; o += 2)
    n[o + 1] ? t[n[o]] = n[o + 1] : t.removeProperty(n[o]);
  !n[n.indexOf("transform") + 1] && t.translate && (t.removeProperty("translate"), t.removeProperty("scale"), t.removeProperty("rotate"));
}, Qt = function(e, n) {
  e.forEach(function(t) {
    return t.a.cache.uncache = 1;
  }), n || e.finalStates.forEach(Vt);
}, vt = "paddingTop,paddingRight,paddingBottom,paddingLeft,gridArea,transition".split(","), Ft = function(e, n, t) {
  var o = e.element, i = e.width, s = e.height, u = e.uncache, l = e.getProp, r = o.style, c = 4, d, g, h;
  if (typeof n != "object" && (n = e), j && t !== 1)
    return j._abs.push({
      t: o,
      b: e,
      a: e,
      sd: 0
    }), j._final.push(function() {
      return (e.cache.uncache = 1) && Vt(e);
    }), o;
  for (g = l("display") === "none", (!e.isVisible || g) && (g && (He(e, ["display"]).display = n.display), e.matrix = n.matrix, e.width = i = e.width || n.width, e.height = s = e.height || n.height), He(e, vt), h = window.getComputedStyle(o); c--; )
    r[vt[c]] = h[vt[c]];
  if (r.gridArea = "1 / 1 / 1 / 1", r.transition = "none", r.position = "absolute", r.width = i + "px", r.height = s + "px", r.top || (r.top = "0px"), r.left || (r.left = "0px"), u)
    d = new Ee(o);
  else if (d = $e(e, et), d.position = "absolute", e.simple) {
    var p = o.getBoundingClientRect();
    d.matrix = new Pe(1, 0, 0, 1, p.left + $t(), p.top + Dt());
  } else
    d.matrix = de(o, !1, !1, !0);
  return d = Ve(d, e, !0), e.x = _e(d.x, 0.01), e.y = _e(d.y, 0.01), o;
}, en = function(e, n) {
  return n !== !0 && (n = ze(n), e = e.filter(function(t) {
    if (n.indexOf((t.sd < 0 ? t.b : t.a).element) !== -1)
      return !0;
    t.t._gsap.renderTransform(1), t.b.isVisible && (t.t.style.width = t.b.width + "px", t.t.style.height = t.b.height + "px");
  })), e;
}, wn = function(e) {
  return tt(e, !0).forEach(function(n) {
    return (n.a.isVisible || n.b.isVisible) && Ft(n.sd < 0 ? n.b : n.a, n.b, 1);
  });
}, Pi = function(e, n) {
  return n && e.idLookup[xt(n).id] || e.elementStates[0];
}, xt = function(e, n, t, o) {
  return e instanceof Ee ? e : e instanceof ue ? Pi(e, o) : new Ee(typeof e == "string" ? Ye(e) || console.warn(e + " not found") : e, n, t);
}, Ei = function(e, n) {
  for (var t = ne.getProperty(e.element, null, "native"), o = e.props = {}, i = n.length; i--; )
    o[n[i]] = (t(n[i]) + "").trim();
  return o.zIndex && (o.zIndex = parseFloat(o.zIndex) || 0), e;
}, yn = function(e, n) {
  var t = e.style || e, o;
  for (o in n)
    t[o] = n[o];
}, Oi = function(e) {
  var n = e.getAttribute("data-flip-id");
  return n || e.setAttribute("data-flip-id", n = "auto-" + ki++), n;
}, In = function(e) {
  return e.map(function(n) {
    return n.element;
  });
}, tn = function(e, n, t) {
  return e && n.length && t.add(e(In(n), t, new ue(n, 0, !0)), 0);
}, Ve = function(e, n, t, o, i, s) {
  var u = e.element, l = e.cache, r = e.parent, c = e.x, d = e.y, g = n.width, h = n.height, p = n.scaleX, O = n.scaleY, b = n.rotation, f = n.bounds, E = s && It && It(u, "transform"), m = e, A = n.matrix, C = A.e, k = A.f, B = e.bounds.width !== f.width || e.bounds.height !== f.height || e.scaleX !== p || e.scaleY !== O || e.rotation !== b, D = !B && e.simple && n.simple && !i, y, _, T, P, $, M, S;
  return D || !r ? (p = O = 1, b = y = 0) : ($ = Li(r), M = $.clone().multiply(n.ctm ? n.matrix.clone().multiply(n.ctm) : n.matrix), b = De(Math.atan2(M.b, M.a) * Gt), y = De(Math.atan2(M.c, M.d) * Gt + b) % 360, p = Math.sqrt(Math.pow(M.a, 2) + Math.pow(M.b, 2)), O = Math.sqrt(Math.pow(M.c, 2) + Math.pow(M.d, 2)) * Math.cos(y * xi), i && (i = ze(i)[0], P = ne.getProperty(i), S = i.getBBox && typeof i.getBBox == "function" && i.getBBox(), m = {
    scaleX: P("scaleX"),
    scaleY: P("scaleY"),
    width: S ? S.width : Math.ceil(parseFloat(P("width", "px"))),
    height: S ? S.height : parseFloat(P("height", "px"))
  }), l.rotation = b + "deg", l.skewX = y + "deg"), t ? (p *= g === m.width || !m.width ? 1 : g / m.width, O *= h === m.height || !m.height ? 1 : h / m.height, l.scaleX = p, l.scaleY = O) : (g = _e(g * p / m.scaleX, 0), h = _e(h * O / m.scaleY, 0), u.style.width = g + "px", u.style.height = h + "px"), o && yn(u, n.props), D || !r ? (c += C - e.matrix.e, d += k - e.matrix.f) : B || r !== n.parent ? (l.renderTransform(1, l), M = de(i || u, !1, !1, !0), _ = $.apply({
    x: M.e,
    y: M.f
  }), T = $.apply({
    x: C,
    y: k
  }), c += T.x - _.x, d += T.y - _.y) : ($.e = $.f = 0, T = $.apply({
    x: C - e.matrix.e,
    y: k - e.matrix.f
  }), c += T.x, d += T.y), c = _e(c, 0.02), d = _e(d, 0.02), s && !(s instanceof Ee) ? E && E.revert() : (l.x = c + "px", l.y = d + "px", l.renderTransform(1, l)), s && (s.x = c, s.y = d, s.rotation = b, s.skewX = y, t ? (s.scaleX = p, s.scaleY = O) : (s.width = g, s.height = h)), s || l;
}, gt = function(e, n) {
  return e instanceof ue ? e : new ue(e, n);
}, kn = function(e, n, t) {
  var o = e.idLookup[t], i = e.alt[t];
  return i.isVisible && (!(n.getElementState(i.element) || i).isVisible || !o.isVisible) ? i : o;
}, mt = [], _t = "width,height,overflowX,overflowY".split(","), Ue, nn = function(e) {
  if (e !== Ue) {
    var n = ye.style, t = ye.clientWidth === window.outerWidth, o = ye.clientHeight === window.outerHeight, i = 4;
    if (e && (t || o)) {
      for (; i--; )
        mt[i] = n[_t[i]];
      t && (n.width = ye.clientWidth + "px", n.overflowY = "hidden"), o && (n.height = ye.clientHeight + "px", n.overflowX = "hidden"), Ue = e;
    } else if (Ue) {
      for (; i--; )
        mt[i] ? n[_t[i]] = mt[i] : n.removeProperty(_n(_t[i]));
      Ue = e;
    }
  }
}, bt = function(e, n, t, o) {
  e instanceof ue && n instanceof ue || console.warn("Not a valid state object."), t = t || {};
  var i = t, s = i.clearProps, u = i.onEnter, l = i.onLeave, r = i.absolute, c = i.absoluteOnLeave, d = i.custom, g = i.delay, h = i.paused, p = i.repeat, O = i.repeatDelay, b = i.yoyo, f = i.toggleClass, E = i.nested, m = i.zIndex, A = i.scale, C = i.fade, k = i.stagger, B = i.spin, D = i.prune, y = ("props" in t ? t : e).props, _ = $e(t, Kt), T = ne.timeline({
    delay: g,
    paused: h,
    repeat: p,
    repeatDelay: O,
    yoyo: b,
    data: "isFlip"
  }), P = _, $ = [], M = [], S = [], oe = [], be = B === !0 ? 1 : B || 0, st = typeof B == "function" ? B : function() {
    return be;
  }, at = e.interrupted || n.interrupted, Rt = T[o !== 1 ? "to" : "from"], Oe, se, Wt, we, q, Y, Se, ce, lt, he, ve, rt, J, ee;
  for (se in n.idLookup)
    ve = n.alt[se] ? kn(n, e, se) : n.idLookup[se], q = ve.element, he = e.idLookup[se], e.alt[se] && q === he.element && (e.alt[se].isVisible || !ve.isVisible) && (he = e.alt[se]), he ? (Y = {
      t: q,
      b: he,
      a: ve,
      sd: he.element === q ? 0 : ve.isVisible ? 1 : -1
    }, S.push(Y), Y.sd && (Y.sd < 0 && (Y.b = ve, Y.a = he), at && He(Y.b, y ? it[y] : ot), C && S.push(Y.swap = {
      t: he.element,
      b: Y.b,
      a: Y.a,
      sd: -Y.sd,
      swap: Y
    })), q._flip = he.element._flip = j ? j.timeline : T) : ve.isVisible && (S.push({
      t: q,
      b: $e(ve, {
        isVisible: 1
      }),
      a: ve,
      sd: 0,
      entering: 1
    }), q._flip = j ? j.timeline : T);
  if (y && (Mt[y] || bn(y)).forEach(function(ge) {
    return _[ge] = function(ke) {
      return S[ke].a.props[ge];
    };
  }), S.finalStates = lt = [], rt = function() {
    for (tt(S), nn(!0), we = 0; we < S.length; we++)
      Y = S[we], J = Y.a, ee = Y.b, D && !J.isDifferent(ee) && !Y.entering ? S.splice(we--, 1) : (q = Y.t, E && !(Y.sd < 0) && we && (J.matrix = de(q, !1, !1, !0)), ee.isVisible && J.isVisible ? (Y.sd < 0 ? (Se = new Ee(q, y, e.simple), Ve(Se, J, A, 0, 0, Se), Se.matrix = de(q, !1, !1, !0), Se.css = Y.b.css, Y.a = J = Se, C && (q.style.opacity = at ? ee.opacity : J.opacity), k && oe.push(q)) : Y.sd > 0 && C && (q.style.opacity = at ? J.opacity - ee.opacity : "0"), Ve(J, ee, A, y)) : ee.isVisible !== J.isVisible && (ee.isVisible ? J.isVisible || (ee.css = J.css, M.push(ee), S.splice(we--, 1), r && E && Ve(J, ee, A, y)) : (J.isVisible && $.push(J), S.splice(we--, 1))), A || (q.style.maxWidth = Math.max(J.width, ee.width) + "px", q.style.maxHeight = Math.max(J.height, ee.height) + "px", q.style.minWidth = Math.min(J.width, ee.width) + "px", q.style.minHeight = Math.min(J.height, ee.height) + "px"), E && f && q.classList.add(f)), lt.push(J);
    var ke;
    if (f && (ke = lt.map(function(F) {
      return F.element;
    }), E && ke.forEach(function(F) {
      return F.classList.remove(f);
    })), nn(!1), A ? (_.scaleX = function(F) {
      return S[F].a.scaleX;
    }, _.scaleY = function(F) {
      return S[F].a.scaleY;
    }) : (_.width = function(F) {
      return S[F].a.width + "px";
    }, _.height = function(F) {
      return S[F].a.height + "px";
    }, _.autoRound = t.autoRound || !1), _.x = function(F) {
      return S[F].a.x + "px";
    }, _.y = function(F) {
      return S[F].a.y + "px";
    }, _.rotation = function(F) {
      return S[F].a.rotation + (B ? st(F, ce[F], ce) * 360 : 0);
    }, _.skewX = function(F) {
      return S[F].a.skewX;
    }, ce = S.map(function(F) {
      return F.t;
    }), (m || m === 0) && (_.modifiers = {
      zIndex: function() {
        return m;
      }
    }, _.zIndex = m, _.immediateRender = t.immediateRender !== !1), C && (_.opacity = function(F) {
      return S[F].sd < 0 ? 0 : S[F].sd > 0 ? S[F].a.opacity : "+=0";
    }), oe.length) {
      k = ne.utils.distribute(k);
      var Tn = ce.slice(oe.length);
      _.stagger = function(F, Yt) {
        return k(~oe.indexOf(Yt) ? ce.indexOf(S[F].swap.t) : F, Yt, Tn);
      };
    }
    if (Ti.forEach(function(F) {
      return t[F] && T.eventCallback(F, t[F], t[F + "Params"]);
    }), d && ce.length) {
      P = $e(_, Kt), "scale" in d && (d.scaleX = d.scaleY = d.scale, delete d.scale);
      for (se in d)
        Oe = $e(d[se], mn), Oe[se] = _[se], !("duration" in Oe) && "duration" in _ && (Oe.duration = _.duration), Oe.stagger = _.stagger, Rt.call(T, ce, Oe, 0), delete P[se];
    }
    (ce.length || M.length || $.length) && (f && T.add(function() {
      return ht(ke, f, T._zTime < 0 ? "remove" : "add");
    }, 0) && !h && ht(ke, f, "add"), ce.length && Rt.call(T, ce, P, 0)), tn(u, $, T), tn(l, M, T);
    var ct = j && j.timeline;
    ct && (ct.add(T, 0), j._final.push(function() {
      return Qt(S, !s);
    })), Wt = T.duration(), T.call(function() {
      var F = T.time() >= Wt;
      F && !ct && Qt(S, !s), f && ht(ke, f, F ? "remove" : "add");
    });
  }, c && (r = S.filter(function(ge) {
    return !ge.sd && !ge.a.isVisible && ge.b.isVisible;
  }).map(function(ge) {
    return ge.a.element;
  })), j) {
    var jt;
    r && (jt = j._abs).push.apply(jt, en(S, r)), j._run.push(rt);
  } else
    r && wn(en(S, r)), rt();
  var ut = j ? j.timeline : T;
  return ut.revert = function() {
    return zt(ut, 1, 1);
  }, ut;
}, Si = function a(e) {
  e.vars.onInterrupt && e.vars.onInterrupt.apply(e, e.vars.onInterruptParams || []), e.getChildren(!0, !1, !0).forEach(a);
}, zt = function(e, n, t) {
  if (e && e.progress() < 1 && (!e.paused() || t))
    return n && (Si(e), n < 2 && e.progress(1), e.kill()), !0;
}, Xe = function(e) {
  for (var n = e.idLookup = {}, t = e.alt = {}, o = e.elementStates, i = o.length, s; i--; )
    s = o[i], n[s.id] ? t[s.id] = s : n[s.id] = s;
}, ue = /* @__PURE__ */ function() {
  function a(n, t, o) {
    if (this.props = t && t.props, this.simple = !!(t && t.simple), o)
      this.targets = In(n), this.elementStates = n, Xe(this);
    else {
      this.targets = ze(n);
      var i = t && (t.kill === !1 || t.batch && !t.kill);
      j && !i && j._kill.push(this), this.update(i || !!j);
    }
  }
  var e = a.prototype;
  return e.update = function(t) {
    var o = this;
    return this.elementStates = this.targets.map(function(i) {
      return new Ee(i, o.props, o.simple);
    }), Xe(this), this.interrupt(t), this.recordInlineStyles(), this;
  }, e.clear = function() {
    return this.targets.length = this.elementStates.length = 0, Xe(this), this;
  }, e.fit = function(t, o, i) {
    for (var s = tt(this.elementStates.slice(0), !1, !0), u = (t || this).idLookup, l = 0, r, c; l < s.length; l++)
      r = s[l], i && (r.matrix = de(r.element, !1, !1, !0)), c = u[r.id], c && Ve(r, c, o, !0, 0, r), r.matrix = de(r.element, !1, !1, !0);
    return this;
  }, e.getProperty = function(t, o) {
    var i = this.getElementState(t) || et;
    return (o in i ? i : i.props || et)[o];
  }, e.add = function(t) {
    for (var o = t.targets.length, i = this.idLookup, s = this.alt, u, l, r; o--; )
      l = t.elementStates[o], r = i[l.id], r && (l.element === r.element || s[l.id] && s[l.id].element === l.element) ? (u = this.elementStates.indexOf(l.element === r.element ? r : s[l.id]), this.targets.splice(u, 1, t.targets[o]), this.elementStates.splice(u, 1, l)) : (this.targets.push(t.targets[o]), this.elementStates.push(l));
    return t.interrupted && (this.interrupted = !0), t.simple || (this.simple = !1), Xe(this), this;
  }, e.compare = function(t) {
    var o = t.idLookup, i = this.idLookup, s = [], u = [], l = [], r = [], c = [], d = t.alt, g = this.alt, h = function(D, y, _) {
      return (D.isVisible !== y.isVisible ? D.isVisible ? l : r : D.isVisible ? u : s).push(_) && c.push(_);
    }, p = function(D, y, _) {
      return c.indexOf(_) < 0 && h(D, y, _);
    }, O, b, f, E, m, A, C, k;
    for (f in o)
      m = d[f], A = g[f], O = m ? kn(t, this, f) : o[f], E = O.element, b = i[f], A ? (k = b.isVisible || !A.isVisible && E === b.element ? b : A, C = m && !O.isVisible && !m.isVisible && k.element === m.element ? m : O, C.isVisible && k.isVisible && C.element !== k.element ? ((C.isDifferent(k) ? u : s).push(C.element, k.element), c.push(C.element, k.element)) : h(C, k, C.element), m && C.element === m.element && (m = o[f]), p(C.element !== b.element && m ? m : C, b, b.element), p(m && m.element === A.element ? m : C, A, A.element), m && p(m, A.element === m.element ? A : b, m.element)) : (b ? b.isDifferent(O) ? h(O, b, E) : s.push(E) : l.push(E), m && p(m, b, m.element));
    for (f in i)
      o[f] || (r.push(i[f].element), g[f] && r.push(g[f].element));
    return {
      changed: u,
      unchanged: s,
      enter: l,
      leave: r
    };
  }, e.recordInlineStyles = function() {
    for (var t = it[this.props] || ot, o = this.elementStates.length; o--; )
      He(this.elementStates[o], t);
  }, e.interrupt = function(t) {
    var o = this, i = [];
    this.targets.forEach(function(s) {
      var u = s._flip, l = zt(u, t ? 0 : 1);
      t && l && i.indexOf(u) < 0 && u.add(function() {
        return o.updateVisibility();
      }), l && i.push(u);
    }), !t && i.length && this.updateVisibility(), this.interrupted || (this.interrupted = !!i.length);
  }, e.updateVisibility = function() {
    this.elementStates.forEach(function(t) {
      var o = t.element.getBoundingClientRect();
      t.isVisible = !!(o.width || o.height || o.top || o.left), t.uncache = 1;
    });
  }, e.getElementState = function(t) {
    return this.elementStates[this.targets.indexOf(Ye(t))];
  }, e.makeAbsolute = function() {
    return tt(this.elementStates.slice(0), !0, !0).map(Ft);
  }, a;
}(), Ee = /* @__PURE__ */ function() {
  function a(n, t, o) {
    this.element = n, this.update(t, o);
  }
  var e = a.prototype;
  return e.isDifferent = function(t) {
    var o = this.bounds, i = t.bounds;
    return o.top !== i.top || o.left !== i.left || o.width !== i.width || o.height !== i.height || !this.matrix.equals(t.matrix) || this.opacity !== t.opacity || this.props && t.props && JSON.stringify(this.props) !== JSON.stringify(t.props);
  }, e.update = function(t, o) {
    var i = this, s = i.element, u = ne.getProperty(s), l = ne.core.getCache(s), r = s.getBoundingClientRect(), c = s.getBBox && typeof s.getBBox == "function" && s.nodeName.toLowerCase() !== "svg" && s.getBBox(), d = o ? new Pe(1, 0, 0, 1, r.left + $t(), r.top + Dt()) : de(s, !1, !1, !0);
    i.getProp = u, i.element = s, i.id = Oi(s), i.matrix = d, i.cache = l, i.bounds = r, i.isVisible = !!(r.width || r.height || r.left || r.top), i.display = u("display"), i.position = u("position"), i.parent = s.parentNode, i.x = u("x"), i.y = u("y"), i.scaleX = l.scaleX, i.scaleY = l.scaleY, i.rotation = u("rotation"), i.skewX = u("skewX"), i.opacity = u("opacity"), i.width = c ? c.width : _e(u("width", "px"), 0.04), i.height = c ? c.height : _e(u("height", "px"), 0.04), t && Ei(i, Mt[t] || bn(t)), i.ctm = s.getCTM && s.nodeName.toLowerCase() === "svg" && gn(s).inverse(), i.simple = o || De(d.a) === 1 && !De(d.b) && !De(d.c) && De(d.d) === 1, i.uncache = 0;
  }, a;
}(), Di = /* @__PURE__ */ function() {
  function a(n, t) {
    this.vars = n, this.batch = t, this.states = [], this.timeline = t.timeline;
  }
  var e = a.prototype;
  return e.getStateById = function(t) {
    for (var o = this.states.length; o--; )
      if (this.states[o].idLookup[t])
        return this.states[o];
  }, e.kill = function() {
    this.batch.remove(this);
  }, a;
}(), $i = /* @__PURE__ */ function() {
  function a(n) {
    this.id = n, this.actions = [], this._kill = [], this._final = [], this._abs = [], this._run = [], this.data = {}, this.state = new ue(), this.timeline = ne.timeline();
  }
  var e = a.prototype;
  return e.add = function(t) {
    var o = this.actions.filter(function(i) {
      return i.vars === t;
    });
    return o.length ? o[0] : (o = new Di(typeof t == "function" ? {
      animate: t
    } : t, this), this.actions.push(o), o);
  }, e.remove = function(t) {
    var o = this.actions.indexOf(t);
    return o >= 0 && this.actions.splice(o, 1), this;
  }, e.getState = function(t) {
    var o = this, i = j, s = je;
    return j = this, this.state.clear(), this._kill.length = 0, this.actions.forEach(function(u) {
      u.vars.getState && (u.states.length = 0, je = u, u.state = u.vars.getState(u)), t && u.states.forEach(function(l) {
        return o.state.add(l);
      });
    }), je = s, j = i, this.killConflicts(), this;
  }, e.animate = function() {
    var t = this, o = j, i = this.timeline, s = this.actions.length, u, l;
    for (j = this, i.clear(), this._abs.length = this._final.length = this._run.length = 0, this.actions.forEach(function(r) {
      r.vars.animate && r.vars.animate(r);
      var c = r.vars.onEnter, d = r.vars.onLeave, g = r.targets, h, p;
      g && g.length && (c || d) && (h = new ue(), r.states.forEach(function(O) {
        return h.add(O);
      }), p = h.compare(U.getState(g)), p.enter.length && c && c(p.enter), p.leave.length && d && d(p.leave));
    }), wn(this._abs), this._run.forEach(function(r) {
      return r();
    }), l = i.duration(), u = this._final.slice(0), i.add(function() {
      l <= i.time() && (u.forEach(function(r) {
        return r();
      }), qt(t, "onComplete"));
    }), j = o; s--; )
      this.actions[s].vars.once && this.actions[s].kill();
    return qt(this, "onStart"), i.restart(), this;
  }, e.loadState = function(t) {
    t || (t = function() {
      return 0;
    });
    var o = [];
    return this.actions.forEach(function(i) {
      if (i.vars.loadState) {
        var s, u = function l(r) {
          r && (i.targets = r), s = o.indexOf(l), ~s && (o.splice(s, 1), o.length || t());
        };
        o.push(u), i.vars.loadState(u);
      }
    }), o.length || t(), this;
  }, e.setState = function() {
    return this.actions.forEach(function(t) {
      return t.targets = t.vars.setState && t.vars.setState(t);
    }), this;
  }, e.killConflicts = function(t) {
    return this.state.interrupt(t), this._kill.forEach(function(o) {
      return o.interrupt(t);
    }), this;
  }, e.run = function(t, o) {
    var i = this;
    return this !== j && (t || this.getState(o), this.loadState(function() {
      i._killed || (i.setState(), i.animate());
    })), this;
  }, e.clear = function(t) {
    this.state.clear(), t || (this.actions.length = 0);
  }, e.getStateById = function(t) {
    for (var o = this.actions.length, i; o--; )
      if (i = this.actions[o].getStateById(t), i)
        return i;
    return this.state.idLookup[t] && this.state;
  }, e.kill = function() {
    this._killed = 1, this.clear(), delete kt[this.id];
  }, a;
}(), U = /* @__PURE__ */ function() {
  function a() {
  }
  return a.getState = function(n, t) {
    var o = gt(n, t);
    return je && je.states.push(o), t && t.batch && a.batch(t.batch).state.add(o), o;
  }, a.from = function(n, t) {
    return t = t || {}, "clearProps" in t || (t.clearProps = !0), bt(n, gt(t.targets || n.targets, {
      props: t.props || n.props,
      simple: t.simple,
      kill: !!t.kill
    }), t, -1);
  }, a.to = function(n, t) {
    return bt(n, gt(t.targets || n.targets, {
      props: t.props || n.props,
      simple: t.simple,
      kill: !!t.kill
    }), t, 1);
  }, a.fromTo = function(n, t, o) {
    return bt(n, t, o);
  }, a.fit = function(n, t, o) {
    var i = o ? $e(o, mn) : {}, s = o || i, u = s.absolute, l = s.scale, r = s.getVars, c = s.props, d = s.runBackwards, g = s.onComplete, h = s.simple, p = o && o.fitChild && Ye(o.fitChild), O = xt(t, c, h, n), b = xt(n, 0, h, O), f = c ? it[c] : ot;
    return c && yn(i, O.props), d && (He(b, f), "immediateRender" in i || (i.immediateRender = !0), i.onComplete = function() {
      Vt(b), g && g.apply(this, arguments);
    }), u && Ft(b, O), i = Ve(b, O, l || p, c, p, i.duration || r ? i : 0), r ? i : i.duration ? ne.to(b.element, i) : null;
  }, a.makeAbsolute = function(n, t) {
    return (n instanceof ue ? n : new ue(n, t)).makeAbsolute();
  }, a.batch = function(n) {
    return n || (n = "default"), kt[n] || (kt[n] = new $i(n));
  }, a.killFlipsOf = function(n, t) {
    (n instanceof ue ? n.targets : ze(n)).forEach(function(o) {
      return o && zt(o._flip, t !== !1 ? 1 : 2);
    });
  }, a.isFlipping = function(n) {
    var t = a.getByTarget(n);
    return !!t && t.isActive();
  }, a.getByTarget = function(n) {
    return (Ye(n) || et)._flip;
  }, a.getElementState = function(n, t) {
    return new Ee(Ye(n), t);
  }, a.convertCoordinates = function(n, t, o) {
    var i = de(t, !0, !0).multiply(de(n));
    return o ? i.apply(o) : i;
  }, a.register = function(n) {
    if (ye = typeof document < "u" && document.body, ye) {
      ne = n, St(ye), ze = ne.utils.toArray, It = ne.core.getStyleSaver;
      var t = ne.utils.snap(0.1);
      _e = function(i, s) {
        return t(parseFloat(i) + s);
      };
    }
  }, a;
}();
U.version = "3.12.0";
typeof window < "u" && window.gsap && window.gsap.registerPlugin(U);
const Bi = { class: "AffiliationList__list" }, Ai = { class: "AffiliationList__name notranslate" }, Mi = { key: 0 }, Vi = /* @__PURE__ */ Q({
  __name: "AffiliationList",
  props: {
    affiliations: {}
  },
  setup(a) {
    const e = a;
    H.registerPlugin(U);
    const n = I(!1), t = I(null), o = I(null), i = () => {
      if (e.affiliations.length <= 2)
        return;
      n.value = !n.value;
      const l = t.value;
      if (!l)
        return;
      const r = l.querySelectorAll(".AffiliationList__item--visibility"), c = U.getState(l), d = U.getState(r), g = U.getState(o.value);
      n.value ? l.classList.remove("AffiliationList--hidden") : l.classList.add("AffiliationList--hidden");
      const h = {
        duration: 0.28,
        ease: "power2.inOut"
      };
      U.from(g, {
        ...h
      }), U.from(c, {
        ...h
      }), U.from(d, {
        nested: !1,
        scale: !0,
        ...h,
        onStart: () => {
          H.to(r, {
            opacity: n.value ? 1 : 0,
            duration: 0.28,
            delay: 0.14
          });
        }
      });
    }, s = z(() => n.value ? "View less" : "See more"), u = z(() => e.affiliations.length > 2);
    return (l, r) => (v(), x("div", {
      ref_key: "affiliationList",
      ref: t,
      class: X(["AffiliationList", { "AffiliationList--hidden": u.value }])
    }, [
      w("ul", Bi, [
        (v(!0), x(re, null, fe(l.affiliations, (c, d) => (v(), x("li", {
          class: X(["AffiliationList__item", { "AffiliationList__item--visibility": d > 1 }]),
          key: `aff-${c.index}`
        }, [
          w("p", Ai, [
            l.affiliations.length > 1 ? (v(), x("span", Mi, Z(c.index) + ".", 1)) : N("", !0),
            Ce(" " + Z(c.affiliations), 1)
          ])
        ], 2))), 128)),
        u.value ? (v(), x("button", {
          key: 0,
          ref_key: "button",
          ref: o,
          class: "AffiliationList__button",
          onClick: r[0] || (r[0] = (c) => i())
        }, Z(s.value), 513)) : N("", !0)
      ])
    ], 2));
  }
});
const Fi = /* @__PURE__ */ w("span", { class: "PeopleList__spacer" }, null, -1), zi = {
  key: 0,
  class: "PeopleList__onBehalfOf"
}, ks = /* @__PURE__ */ Q({
  __name: "PeopleList",
  props: {
    peopleList: {},
    affiliations: {},
    onBehalfOf: {}
  },
  setup(a) {
    const e = a;
    H.registerPlugin(U);
    const n = I(!1), t = I(null), o = I(null), i = z(() => {
      const f = (E) => E.affiliationIndexes !== void 0;
      if (Array.isArray(e.affiliations) && e.affiliations.length) {
        if (!e.peopleList.length || !f(e.peopleList[0]))
          throw new Error(
            "If the affiliations property is defined the peopleList property must implement items of the interface IIndexedPerson"
          );
        return {
          people: e.peopleList,
          organizations: e.affiliations
        };
      }
      return Zn(e.peopleList);
    }), s = z(() => i.value.people), u = z(() => s.value[s.value.length - 1]), l = z(() => s.value.slice(0, -1) || []), r = z(() => i.value.organizations), c = z(() => l.value.length > 9), d = z(() => Math.min(l.value.length, 13) - 8), g = z(() => c.value ? l.value.length - 8 : 0), h = z(() => n.value ? "See less" : `+${g.value} more`), p = z(() => d.value < 1 ? "PeopleList__list--0" : "PeopleList__list--" + d.value), O = () => {
      var B, D;
      const f = t.value, E = o.value;
      if (!f || !E || !u)
        return;
      const m = U.getState(f), A = U.getState(f.querySelectorAll(".PeopleListItem")), C = U.getState(
        f.querySelector(".PeopleList__button")
      );
      n.value ? (B = t.value) == null || B.classList.remove("PeopleList__list--hidden") : (D = t.value) == null || D.classList.add("PeopleList__list--hidden");
      const k = {
        duration: g.value < 5 ? 0.3 : 0.4,
        ease: "power2.inOut",
        prune: !0
      };
      U.from(m, {
        absolute: !1,
        ...k
      }), U.from(C, {
        ...k
      }), U.from(A, {
        nested: !1,
        scale: !0,
        ...k
      });
    }, b = () => {
      n.value = !n.value, Ie(() => {
        O();
      });
    };
    return (f, E) => (v(), x("div", {
      ref_key: "mainEl",
      ref: o,
      class: "PeopleList"
    }, [
      w("ul", {
        ref_key: "peopleListEl",
        ref: t,
        class: X(["PeopleList__list PeopleList__list--hidden", p.value])
      }, [
        (v(!0), x(re, null, fe(l.value, (m) => (v(), W(L(Jt), {
          key: m.loopUserId,
          "full-name": m.fullName,
          "user-id": m.loopUserId,
          symbols: m.symbols,
          "show-indexes": r.value.length > 1,
          "on-behalf-of": m.onBehalfOf,
          "affiliation-indexes": m.affiliationIndexes
        }, null, 8, ["full-name", "user-id", "symbols", "show-indexes", "on-behalf-of", "affiliation-indexes"]))), 128)),
        c.value ? (v(), x("button", {
          key: 0,
          class: "PeopleList__button PeopleList__button--more",
          onClick: E[0] || (E[0] = (m) => b())
        }, Z(h.value), 1)) : N("", !0),
        u.value ? (v(), W(L(Jt), {
          key: 1,
          class: "last-people",
          "full-name": u.value.fullName,
          "user-id": u.value.loopUserId,
          symbols: u.value.symbols,
          "show-indexes": r.value.length > 1,
          "on-behalf-of": u.value.onBehalfOf,
          "affiliation-indexes": u.value.affiliationIndexes
        }, null, 8, ["full-name", "user-id", "symbols", "show-indexes", "on-behalf-of", "affiliation-indexes"])) : N("", !0),
        Fi
      ], 2),
      f.onBehalfOf ? (v(), x("span", zi, " On behalf of " + Z(f.onBehalfOf), 1)) : N("", !0),
      R(L(Vi), { affiliations: r.value }, null, 8, ["affiliations"])
    ], 512));
  }
}), Ni = /* @__PURE__ */ w("p", { class: "CardRT2__partOf" }, "Part of a Research Topic", -1), Ri = { class: "CardRT2__wrap" }, Wi = { key: 0 }, ji = { key: 1 }, Yi = /* @__PURE__ */ w("div", { class: "CardRT2__wrap--line" }, null, -1), xs = /* @__PURE__ */ Q({
  __name: "CardRT2",
  props: {
    id: {},
    title: {},
    isOpenForSubmission: { type: Boolean },
    totalArticles: {},
    totalViews: {},
    link: {},
    heading: { default: "h3" }
  },
  setup(a) {
    const e = a, n = z(() => {
      const t = [];
      return e.totalViews && t.push({ value: e.totalViews, text: "views" }), e.totalArticles && t.push({ value: e.totalArticles, text: "articles" }), t;
    });
    return (t, o) => (v(), W(L(zn), {
      link: t.link,
      class: "CardRT2"
    }, {
      body: le(() => [
        Ni,
        w("div", Ri, [
          R(L(Vn), {
            class: "CardRT2__title",
            title: t.title,
            heading: t.heading
          }, null, 8, ["title", "heading"]),
          t.isOpenForSubmission ? (v(), x("i", Wi, "  ")) : N("", !0),
          t.isOpenForSubmission ? (v(), x("span", ji, "Submission open")) : N("", !0),
          R(L(an), {
            metrics: n.value,
            thousandToK: !0
          }, null, 8, ["metrics"]),
          Yi
        ])
      ]),
      _: 1
    }, 8, ["link"]));
  }
});
function Hi(a, e, n, t, o) {
  const i = I(null), s = I(null), u = I(!1), l = o || 10, r = () => {
    s.value && s.value.disconnect();
  }, c = () => {
    r(), g();
  }, d = () => {
    !(n != null && n.value) || u.value || (u.value = !0, c(), setTimeout(() => {
      c(), u.value = !1;
    }, 100));
  }, g = () => {
    const b = {
      root: t ? t.value : null,
      rootMargin: `${-l}px 0px 0px 0px`,
      threshold: [0, 0.25, 0.5, 0.75, 1]
    };
    s.value = new IntersectionObserver(p, b), a.value.forEach((f) => {
      var m;
      const E = document.getElementById(f[e]);
      E && ((m = s.value) == null || m.observe(E));
    });
  }, h = I(
    a.value.map((b) => ({
      id: b[e],
      ratio: 0,
      top: 0
    }))
  ), p = (b) => {
    n != null && n.value && b.forEach((f) => {
      const E = h.value.findIndex(
        (m) => m.id === f.target.id
      );
      E < 0 || (h.value[E] = {
        id: f.target.id,
        ratio: f.intersectionRatio,
        top: f.intersectionRect.top
      });
    });
  }, O = z(() => {
    const b = window.innerHeight / 2.5, f = h.value.filter((C) => C.ratio), E = f.filter(
      (C) => C.top === l
    );
    if (E.length > 0) {
      const C = E.filter((k) => k.ratio > 0.5).sort((k, B) => k.ratio - B.ratio);
      if (C.length > 0) {
        let k = C[0];
        return k ? k.id : "";
      }
    }
    if ((t == null ? void 0 : t.value) !== null) {
      if (f.length === 1)
        return f[0].id;
      const C = f.filter((k) => k.ratio === 1);
      if (C.length > 0) {
        let B = C.filter(
          (D) => D.top < b && D.top >= l
        ).sort((D, y) => D.top - y.top)[0];
        return B ? B.id : "";
      }
    }
    let A = f.filter(
      (C) => C.top < b && C.top >= l
    ).sort((C, k) => k.top - C.top)[0];
    return A ? A.id : "";
  });
  return K(
    () => O.value,
    () => {
      n != null && n.value && O.value.length > 0 && (i.value = O.value);
    }
  ), K(
    () => a.value,
    () => {
      a.value.forEach((b) => {
        const f = b[e];
        h.value.find((m) => m.id === f) || h.value.push({
          id: f,
          ratio: 0,
          top: 0
        });
      }), Ie(() => {
        c();
      });
    }
  ), pe(() => {
    g(), t != null && t.value ? (t.value.addEventListener("scrollend", d), t.value.addEventListener("touchend", d)) : (window.addEventListener("scrollend", d), window.addEventListener("touchend", d)), setTimeout(() => c, 300);
  }), nt(() => {
    r(), t != null && t.value ? (t.value.removeEventListener("scrollend", d), t.value.removeEventListener("touchend", d)) : (window.removeEventListener("scrollend", d), window.removeEventListener("touchend", d));
  }), {
    activeId: i
  };
}
H.registerPlugin(Be);
function Ui(a, e) {
  const n = I(null), t = [], o = () => {
    if (t.length > 0) {
      const s = t[t.length - 1], u = window.scrollY, l = s.offsetTop + s.offsetHeight;
      if (u > l) {
        const r = a.value.length - 1;
        n.value = a.value[r][e];
      }
    }
  }, i = () => {
    Be.refresh(), setTimeout(() => {
      o();
    }, 300);
  };
  return pe(() => {
    a.value.forEach((s) => {
      t.push(
        document.getElementById(s[e])
      );
    }), t.forEach((s, u) => {
      Be.create({
        trigger: s,
        start: "top 25%",
        end: "bottom center",
        markers: !1,
        onEnter: () => {
          n.value = a.value[u][e];
        },
        onEnterBack: () => {
          n.value = a.value[u][e];
        }
      });
    }), window.addEventListener("scroll", o);
  }), nt(() => {
    Be.getAll().forEach((s) => {
      s.kill();
    }), window.removeEventListener("scroll", o);
  }), {
    activeId: n,
    updateScrollTrigger: i
  };
}
function Nt(a) {
  const e = I(!1), n = () => {
    if (!a.value)
      return;
    const o = a.value.offsetHeight, i = a.value.scrollHeight;
    e.value = i > o;
  };
  let t = null;
  return pe(() => {
    !a.value || typeof window > "u" || (t = new ResizeObserver(() => {
      n();
    }), n(), t.observe(a.value));
  }), nt(() => {
    t && t.disconnect();
  }), { hasScrollbar: e };
}
const Xi = {
  key: 0,
  class: "Outline__title"
}, Ji = /* @__PURE__ */ w("span", { class: "Outline__icon" }, null, -1), qi = { class: "Outline__list" }, Gi = ["href", "onClick", "data-event"], Zi = /* @__PURE__ */ w("span", null, null, -1), Ki = { class: "Outline__link__text" }, Ts = /* @__PURE__ */ Q({
  __name: "Outline",
  props: {
    items: { default: () => new Array() }
  },
  setup(a) {
    const e = a;
    H.registerPlugin(U);
    const n = I(0), t = I(null), o = I(null), i = I(null), s = I(null), u = I(!0), l = I(null), { hasScrollbar: r } = Nt(l), c = V("isDesktopApp"), d = V("emitter"), g = I(0), h = I(!1), p = I(!1), O = () => {
      if (typeof window > "u")
        return null;
      const P = document.querySelectorAll(".Outline__item")[n.value];
      return P || null;
    }, b = () => {
      if (p.value)
        return;
      const P = O();
      P && P.scrollIntoView({
        behavior: Gn.isFirefox() ? "auto" : "smooth",
        block: "nearest",
        inline: "start"
      });
    }, f = (P, $) => {
      var S;
      const M = Math.abs(n.value - $);
      if (P) {
        const oe = ((S = document.getElementById(e.items[$].targetId)) == null ? void 0 : S.offsetTop) || 200, be = window.scrollY, st = Math.abs(oe - be);
        return Math.min(2, Math.max(st / 1e4, 0.24));
      } else
        return Math.max(Math.min(0.1 * M, 0.5), 0.2);
    }, E = (P, $ = 200, M = !1) => {
      if (p.value)
        return;
      u.value = !1, M && (p.value = !0);
      const S = U.getState(t.value);
      n.value = P;
      const oe = O();
      t.value && oe && oe.insertBefore(t.value, oe.firstChild);
      const be = f(M, P);
      U.from(S, {
        duration: be,
        ease: "linear",
        scale: !0,
        absolute: !1,
        transformOrigin: "left top",
        onComplete: () => {
          setTimeout(() => {
            u.value = !0, p.value = !1;
          }, $);
        }
      });
    }, m = (P, $, M) => {
      if (P.preventDefault(), c.value) {
        if (!u.value)
          return;
        E(M, 100, !0), setTimeout(() => {
          var be;
          const S = ((be = document.getElementById(e.items[n.value].targetId)) == null ? void 0 : be.offsetTop) || 200, oe = window.scrollY;
          Math.abs(S - oe) > 30 && E(M, 100, !0);
        }, 400);
      }
      d.emit("go-to-id", $.targetId);
    }, A = () => {
      typeof window > "u" || e.items.forEach((P) => {
        document.getElementById(P.targetId) || console.warn(
          `The item "${P.text}" has no target element with id "${P.targetId}" inside of the article body.`
        );
      });
    }, C = () => {
      var $;
      if (!o.value)
        return;
      const P = c.value ? i.value : s.value;
      P && (($ = o.value.parentElement) == null || $.removeChild(o.value), P.appendChild(o.value));
    }, k = () => {
      const P = O();
      c.value && t.value && P && P.insertBefore(t.value, P.firstChild);
    }, B = () => {
      const { pause: P } = Mn(() => {
        typeof document > "u" || (s.value ? P() : (s.value = document.getElementById("outline-content"), s.value && C()));
      }, 200);
    }, { activeId: D, updateScrollTrigger: y } = Ui(
      I(e.items),
      "targetId"
    ), _ = (P) => e.items.findIndex(($) => $.targetId === P);
    K(
      () => D.value,
      (P) => {
        setTimeout(() => {
          if (!D.value || P !== D.value || p.value)
            return;
          const $ = _(D.value);
          if ($ > -1 && $ !== n.value) {
            const S = Math.abs($ - n.value) === 1 ? 0 : f(!0, $);
            setTimeout(() => {
              p.value || (E($, 0), n.value = $, b());
            }, S);
          }
        }, 100);
      }
    ), K(
      () => c.value,
      () => {
        C(), c.value && E(n.value, 100);
      }
    );
    const T = (P) => {
      h.value = P, !(!P || c.value) && (b(), setTimeout(() => {
        b();
      }, 300));
    };
    return pe(() => {
      B(), Ie(() => {
        k(), A(), g.value = 1;
      });
      const P = window.location.hash.substring(1), $ = e.items.findIndex((M) => M.targetId === P);
      if ($ !== n.value && $ > -1) {
        const M = f(!0, n.value);
        setTimeout(() => b(), M * 1e3);
      }
      d.on("is-open-side-panel", T), d.on("figures-on-load", y);
    }), nt(() => {
      d.off("is-open-side-panel", T);
    }), (P, $) => (v(), x("div", {
      ref_key: "wrapperDesktopEl",
      ref: i,
      id: "outline-desktop-wrapper",
      class: "OutlineWrapper"
    }, [
      w("div", {
        ref_key: "outlineEl",
        ref: o,
        class: X(["Outline", { "Outline--scrollbar": L(r) }])
      }, [
        L(c) ? (v(), x("p", Xi, [
          Ji,
          Ce("Outline ")
        ])) : N("", !0),
        w("nav", {
          ref_key: "navEl",
          ref: l,
          class: "Outline__nav"
        }, [
          w("ul", qi, [
            (v(!0), x(re, null, fe(P.items, (M, S) => (v(), x("li", {
              key: M.targetId,
              class: X(["Outline__item", { "Outline__item--active": S === n.value }])
            }, [
              w("a", {
                href: `#${M.targetId}`,
                class: X(["Outline__link", { "Outline__link--active": S === n.value }]),
                onClick: (oe) => m(oe, M, S),
                "data-event": P.$ga.getDataEventValue("OutlineItem", "a", M.targetId)
              }, [
                Zi,
                w("p", Ki, Z(M.text), 1)
              ], 10, Gi)
            ], 2))), 128))
          ]),
          w("div", {
            ref_key: "activeBgEl",
            ref: t,
            class: "Outline__activeBg",
            style: Ln({ opacity: g.value })
          }, null, 4)
        ], 512)
      ], 2)
    ], 512));
  }
}), Qi = { class: "FiguresOutlineItem" }, eo = { class: "FiguresOutlineItem__title" }, to = ["data-event"], no = ["data-event"], io = { class: "FiguresOutlineItem__table__icon" }, oo = { class: "FiguresOutlineItem__table__description" }, so = ["href", "aria-label", "data-event"], ao = /* @__PURE__ */ Q({
  __name: "FiguresOutlineItem",
  props: {
    index: {},
    title: {},
    targetId: {},
    image: {},
    description: {},
    descriptionNodes: {},
    downloadUrl: {},
    tableNodes: {},
    tableFootNodes: {},
    statementNodes: {}
  },
  emits: ["figure-on-click"],
  setup(a, { emit: e }) {
    const n = a, t = V("emitter"), o = () => {
      e("figure-on-click", n.index), t.emit("close-info-drawer");
    }, i = (u, l) => {
      u.preventDefault(), t.emit("go-to-id", l);
    }, s = z(() => `View ${n.title} in article`);
    return (u, l) => (v(), x("li", Qi, [
      w("p", eo, Z(u.title), 1),
      u.image ? (v(), x("button", {
        key: 0,
        class: "FiguresOutlineItem__image",
        onClick: o,
        "data-event": u.$ga.getDataEventValue("FigureOutline", "button", "openLightbox")
      }, [
        R(L(Lt), {
          class: "FiguresOutlineItem__image",
          sources: u.image.sources,
          "image-alt": u.image.imageAlt,
          "lazy-loading-attr": !0
        }, null, 8, ["sources", "image-alt"]),
        R(L(Ht), {
          fill: "var(--maincolor50)",
          size: "lg"
        })
      ], 8, to)) : (v(), x("button", {
        key: 1,
        class: "FiguresOutlineItem__table",
        onClick: o,
        "data-event": u.$ga.getDataEventValue("FigureOutline", "button", "openTable")
      }, [
        w("div", io, [
          R(L(Ht), { size: "lg" })
        ]),
        w("p", oo, Z(n.description), 1)
      ], 8, no)),
      w("a", {
        href: `#${u.targetId}`,
        class: "FiguresOutlineItem__link",
        "aria-label": s.value,
        onClick: l[0] || (l[0] = (r) => i(r, u.targetId)),
        "data-event": u.$ga.getDataEventValue("FigureOutline", "a", "viewInArticle")
      }, [
        R(L(Nn)),
        Ce("View in article")
      ], 8, so)
    ]));
  }
});
const lo = { class: "FiguresOutline__title" }, Ls = /* @__PURE__ */ Q({
  __name: "FiguresOutline",
  props: {
    figures: {}
  },
  emits: ["figure-on-click"],
  setup(a, { emit: e }) {
    const n = (c) => {
      e("figure-on-click", c);
    }, t = I(null), { hasScrollbar: o } = Nt(t), i = I(null), s = I(null), u = I(null), l = V("isDesktopApp"), r = () => {
      var c, d;
      l.value ? (c = s.value) == null || c.appendChild(i.value) : (d = u.value) == null || d.appendChild(i.value);
    };
    return K(
      () => l.value,
      () => {
        r();
      }
    ), pe(() => {
      u.value = document.getElementById("figures-content"), r();
    }), (c, d) => (v(), x("div", {
      ref_key: "wrapperDesktopEl",
      ref: s,
      id: "figures-desktop-wrapper",
      class: "FiguresOutlineWrapper"
    }, [
      c.figures ? (v(), x("div", {
        key: 0,
        ref_key: "figuresEl",
        ref: i,
        class: X(["FiguresOutline", { "FiguresOutline--scrollbar": L(o) }])
      }, [
        w("div", lo, [
          R(L(Rn), { size: "md" }),
          Ce("Figures and Tables ")
        ]),
        w("ul", {
          class: "FiguresOutline__list",
          ref_key: "navEl",
          ref: t
        }, [
          (v(!0), x(re, null, fe(c.figures, (g, h) => (v(), W(L(ao), {
            key: h,
            title: g.title,
            targetId: g.targetId,
            image: g.image ? g.image : void 0,
            description: g.description,
            index: h,
            onFigureOnClick: n
          }, null, 8, ["title", "targetId", "image", "description", "index"]))), 128))
        ], 512)
      ], 2)) : N("", !0)
    ], 512));
  }
}), ro = { class: "Lightbox__imageControls" }, uo = { class: "Lightbox__range Lightbox--hiddenDevices" }, Je = 4, Ne = 1, co = 200, fo = /* @__PURE__ */ Q({
  __name: "LightboxImage",
  props: {
    item: {}
  },
  emits: ["download-image"],
  setup(a, { emit: e }) {
    const n = a;
    Cn((f) => ({
      "10418bca": r.value
    }));
    const t = I(null), o = I(null), i = I(1), s = I(!0), u = I(!1), l = z(() => {
      var E;
      return (((E = n.item.image) == null ? void 0 : E.sources) || [])[0].src;
    }), r = z(() => `${(i.value - Ne) * 100 / (Je - Ne)}%`), c = z(() => n.item.downloadUrl || ""), d = async () => {
      fetch(c.value, { headers: {} }).then((f) => f.blob()).then((f) => {
        const E = URL.createObjectURL(f);
        Object.assign(document.createElement("a"), {
          href: E,
          download: c.value
        }).click(), URL.revokeObjectURL(E), e("download-image", !0);
      }).catch(() => e("download-image", !1));
    }, g = {
      step: 0.25,
      minScale: Ne,
      maxScale: Je,
      duration: co,
      roundPixels: !0,
      pinchAndPan: !0
    }, h = () => {
      u.value = !1, o.value = null, i.value = 1;
      const f = new Image();
      f.src = l.value, f.onload = () => {
        var k, B;
        if (!t.value)
          return;
        const E = ((k = t.value) == null ? void 0 : k.offsetHeight) / ((B = t.value) == null ? void 0 : B.offsetWidth), m = f.height / f.width;
        if (s.value = f.width > f.height && E > m, !t.value)
          return;
        const A = t.value.querySelector(
          ".FrontiersImage .FrontiersImage"
        );
        o.value = Jn(A, g);
        const C = setInterval(() => {
          o.value && (setTimeout(() => {
            u.value = !0;
          }, 100), clearInterval(C));
        }, 50);
      };
    }, p = () => {
      o.value && (o.value.zoomIn(), i.value = o.value.getScale());
    }, O = () => {
      o.value && (o.value.zoomOut(), i.value = o.value.getScale());
    }, b = () => {
      o.value && o.value.zoom(i.value);
    };
    return pe(() => {
      h();
    }), (f, E) => (v(), x(re, null, [
      w("div", ro, [
        R(L(Ae), {
          class: "Lightbox--hiddenDevices",
          color: "Black",
          size: "Large",
          label: "Zoom out",
          "is-disabled": i.value <= Ne,
          "show-tooltip": !0,
          "tooltip-position": ["bottom", "center"],
          "data-event": f.$ga.getDataEventValue("Lightbox", "button", "zoomOut"),
          onClick: O
        }, {
          default: le(() => [
            R(L(Wn), { size: "lg" })
          ]),
          _: 1
        }, 8, ["is-disabled", "data-event"]),
        w("div", uo, [
          Le(w("input", {
            ref: "rangeEl",
            "onUpdate:modelValue": E[0] || (E[0] = (m) => i.value = m),
            max: Je,
            min: Ne,
            step: "0.1",
            type: "range",
            onInput: b
          }, null, 544), [
            [
              Pn,
              i.value,
              void 0,
              { number: !0 }
            ]
          ])
        ]),
        R(L(Ae), {
          class: "Lightbox--hiddenDevices",
          color: "Black",
          size: "Large",
          label: "Zoom in",
          "is-disabled": i.value >= Je,
          "show-tooltip": !0,
          "tooltip-position": ["bottom", "center"],
          "data-event": f.$ga.getDataEventValue("Lightbox", "button", "zoomIn"),
          onClick: p
        }, {
          default: le(() => [
            R(L(jn), { size: "lg" })
          ]),
          _: 1
        }, 8, ["is-disabled", "data-event"]),
        R(L(Ae), {
          color: "Black",
          size: "Large",
          label: "Download figure",
          "show-tooltip": !0,
          "tooltip-position": ["bottom", "center"],
          "data-event": f.$ga.getDataEventValue("Lightbox", "button", "downloadImage"),
          onClick: d
        }, {
          default: le(() => [
            R(L(ln), { size: "lg" })
          ]),
          _: 1
        }, 8, ["data-event"])
      ]),
      f.item.image ? (v(), x("div", {
        key: 0,
        ref_key: "wrapperEl",
        ref: t,
        class: X([{
          "Lightbox__mask--landscape": s.value,
          "Lightbox__mask--hidden": !u.value
        }, "Lightbox__mask"])
      }, [
        R(L(Lt), En(On(f.item.image)), null, 16)
      ], 2)) : N("", !0)
    ], 64));
  }
});
const po = /* @__PURE__ */ qn(fo, [["__scopeId", "data-v-0bf1d24c"]]), ho = { class: "Lightbox__table" }, vo = {
  key: 0,
  class: "Lightbox__scrollContainer"
}, go = {
  key: 1,
  class: "Lightbox__scrollContainer Algorithm"
}, mo = /* @__PURE__ */ Q({
  __name: "LightboxNodes",
  props: {
    item: {}
  },
  setup(a) {
    const e = a, n = () => e.item.tableNodes, t = () => e.item.statementNodes;
    return (o, i) => {
      var s, u;
      return v(), x("div", ho, [
        (s = o.item.tableNodes) != null && s.length ? (v(), x("div", vo, [
          (v(), W(ie(n)))
        ])) : N("", !0),
        (u = o.item.statementNodes) != null && u.length ? (v(), x("div", go, [
          w("ul", null, [
            (v(), W(ie(t)))
          ])
        ])) : N("", !0)
      ]);
    };
  }
}), _o = { class: "Lightbox__wrapper" }, bo = { class: "Lightbox__info" }, wo = ["data-event"], yo = {
  key: 0,
  class: "Lightbox__description"
}, Io = {
  key: 1,
  class: "Lightbox__description"
}, ko = {
  key: 2,
  class: "Lightbox__tableFoot"
}, xo = /* @__PURE__ */ Q({
  __name: "LightboxItem",
  props: {
    item: {}
  },
  emits: ["download-image"],
  setup(a, { emit: e }) {
    const n = a, t = I(null), o = I(!0), i = V("isExpanded"), s = () => {
      o.value = !o.value, t.value && dt.to(t.value, {
        onStart: () => {
          dt.set(t.value, { overflow: "hidden" });
        },
        height: o.value ? "auto" : 0,
        duration: 0.24,
        ease: "power2.inOut",
        onComplete: () => {
          dt.set(t.value, { overflow: "auto" });
        }
      });
    }, u = () => n.item.descriptionNodes, l = () => n.item.tableFootNodes;
    return (r, c) => {
      var d, g, h, p, O;
      return v(), x("div", _o, [
        r.item.image ? (v(), W(po, {
          key: 0,
          item: r.item
        }, null, 8, ["item"])) : (v(), W(mo, {
          key: 1,
          item: r.item
        }, null, 8, ["item"])),
        w("div", bo, [
          (d = r.item.descriptionNodes) != null && d.length || (g = r.item.description) != null && g.length ? (v(), x("button", {
            key: 0,
            class: "Lightbox__info__trigger",
            "data-event": r.$ga.getDataEventValue("Lightbox", "button", "toggleCaption"),
            onClick: s
          }, [
            w("div", {
              class: X(["Lightbox__info__trigger__caption", {
                "Lightbox__info__trigger__caption--hidden": !o.value
              }])
            }, " Caption ", 2)
          ], 8, wo)) : N("", !0),
          w("div", {
            ref_key: "infoEl",
            ref: t,
            class: X(["Lightbox__info__scroll", { "Lightbox__info__scroll--expanded": L(i) }])
          }, [
            (h = r.item.descriptionNodes) != null && h.length ? (v(), x("div", yo, [
              (v(), W(ie(u)))
            ])) : (v(), x("p", Io, Z(r.item.description), 1)),
            (p = r.item.tableFootNodes) != null && p.length ? (v(), x("div", ko, [
              (O = r.item.tableFootNodes) != null && O.length ? (v(), W(ie(l), { key: 0 })) : N("", !0)
            ])) : N("", !0)
          ], 2)
        ])
      ]);
    };
  }
}), To = { class: "Lightbox__grid" }, Lo = { class: "Lightbox__title" }, Co = ["data-event"], Po = /* @__PURE__ */ w("div", { class: "Lightbox__spacer" }, null, -1), Eo = {
  key: 0,
  class: "Lightbox__controlsSpace"
}, Oo = { class: "Lightbox__footerNav" }, So = ["data-event"], Do = /* @__PURE__ */ w("span", null, "Previous", -1), $o = [
  Do
], Bo = ["data-event"], Ao = /* @__PURE__ */ w("span", null, "Next", -1), Mo = [
  Ao
], Cs = /* @__PURE__ */ Q({
  __name: "Lightbox",
  props: {
    items: { default: () => new Array() },
    isOpen: { type: Boolean, default: !1 },
    currentIndex: { default: 0 }
  },
  emits: ["close"],
  setup(a, { emit: e }) {
    const n = a, t = V("emitter"), o = rn, i = V("isDesktopApp"), s = I(0), u = I(!1), l = I(null), { isSwiping: r, direction: c } = sn(l);
    te("isExpanded", u);
    const d = z(() => n.items[s.value]), g = z(() => s.value <= 0), h = z(() => s.value >= n.items.length - 1), p = () => {
      g.value || (s.value -= 1, Ie(() => {
        f.value.add(s.value);
      }));
    }, O = () => {
      h.value || (s.value += 1, Ie(() => {
        f.value.add(s.value);
      }));
    }, b = () => {
      e("close");
    }, f = I(/* @__PURE__ */ new Set());
    K(
      [() => n.currentIndex, () => n.isOpen],
      ([m, A]) => {
        A && (s.value = m, Ie(() => {
          f.value.add(m);
        }));
      },
      { immediate: !0 }
    ), K(r, () => {
      i.value || (c.value === "up" ? u.value = !0 : c.value === "down" && (u.value = !1));
    });
    const E = (m, A) => {
      m.preventDefault(), b(), setTimeout(() => {
        t.emit("go-to-id", A);
      }, 200);
    };
    return (m, A) => Le((v(), x("div", {
      class: X([{ "Lightbox--open": m.isOpen }, "Lightbox"])
    }, [
      w("button", {
        "aria-label": "Close view",
        class: "Lightbox__overlay",
        onClick: b
      }),
      w("div", To, [
        w("div", {
          class: X(["Lightbox__main", { "Lightbox__main--expanded": u.value }])
        }, [
          w("div", {
            ref_key: "headerMobile",
            ref: l,
            class: "Lightbox__header"
          }, [
            w("p", Lo, Z(d.value.title), 1),
            w("button", {
              class: "Lightbox__article",
              "data-event": m.$ga.getDataEventValue("Lightbox", "button", "viewInArticle"),
              onClick: A[0] || (A[0] = (C) => E(C, d.value.targetId))
            }, " View in article ", 8, Co),
            Po,
            d.value.image ? (v(), x("div", Eo)) : N("", !0),
            R(L(Ae), {
              color: "Black",
              size: "Large",
              label: "Close view",
              "show-tooltip": !0,
              "tooltip-position": ["bottom", "center"],
              "data-event": m.$ga.getDataEventValue("Lightbox", "button", "close"),
              onClick: b
            }, {
              default: le(() => [
                R(L(Yn), { size: "lg" })
              ]),
              _: 1
            }, 8, ["data-event"])
          ], 512),
          (v(), W(Sn, null, [
            (v(!0), x(re, null, fe(m.items, (C, k) => (v(), x(re, {
              key: C.targetId
            }, [
              f.value.has(k) ? Le((v(), W(xo, {
                key: 0,
                item: C
              }, null, 8, ["item"])), [
                [Tt, s.value === k]
              ]) : N("", !0)
            ], 64))), 128))
          ], 1024)),
          w("div", Oo, [
            w("button", {
              class: X(["Lightbox__nav Lightbox__nav--prev", { "Lightbox__nav--disabled": g.value }]),
              "data-event": m.$ga.getDataEventValue("Lightbox", "button", "previous"),
              onClick: p
            }, $o, 10, So),
            w("button", {
              class: X(["Lightbox__nav Lightbox__nav--next", { "Lightbox__nav--disabled": h.value }]),
              "data-event": m.$ga.getDataEventValue("Lightbox", "button", "next"),
              onClick: O
            }, Mo, 10, Bo)
          ])
        ], 2)
      ])
    ], 2)), [
      [
        L(o),
        m.isOpen,
        void 0,
        { noDelay: !0 }
      ]
    ]);
  }
}), Vo = ["tab"], Fo = ["data-event", "href", "target", "rel"], zo = { class: "ToolbarItem__text" }, No = /* @__PURE__ */ Q({
  __name: "ToolbarItem",
  props: {
    tab: {}
  },
  setup(a) {
    const e = a, n = V("emitter"), t = V("isOpenSidePanel"), o = V("animations"), i = V("tabs"), s = V("activeTab"), u = V("isClickingOnTab"), l = V("isChangingTab"), r = V("isDesktopApp"), c = V("goToTab"), d = Ct();
    c.value = (p) => {
      if (!i.value.some(
        (b) => {
          var f;
          return b.targetId === p || ((f = s.value) == null ? void 0 : f.targetId);
        }
      )) {
        console.warn(`Tab with id ${p} does not exist`);
        return;
      }
      if (l.value = !0, !t.value) {
        t.value = !0;
        const b = r.value ? 0 : 100;
        setTimeout(o.showSidePanel, b);
      }
      u.value = !0, p ? (s.value = un(i.value, p), p === "outline" && n.emit("open-outline-id"), window.location.hash = s.value.targetId) : s.value && (window.location.hash = s.value.targetId), setTimeout(() => {
        l.value = !1;
      }, d + 100);
    };
    const g = z(() => !s.value || e.tab.isExternalLink ? !1 : e.tab.targetId === s.value.targetId && !l.value && r.value), h = (p) => {
      e.tab.isExternalLink || (p.preventDefault(), c.value(e.tab.targetId));
    };
    return (p, O) => Le((v(), x("li", {
      class: "ToolbarItem",
      tab: p.tab.targetId
    }, [
      w("a", {
        class: X([{
          "ToolbarItem__action--active": g.value
        }, "ToolbarItem__action"]),
        "data-event": p.$ga.getDataEventValue("InfoDrawer", "a", p.tab.targetId),
        href: p.tab.isExternalLink ? p.tab.href : `#${p.tab.targetId}`,
        target: p.tab.isExternalLink ? p.tab.target : void 0,
        rel: p.tab.isExternalLink ? p.tab.rel : void 0,
        onClick: h
      }, [
        (v(), W(ie(L(Fe)(p.tab.icon)), { size: "lg" })),
        w("span", zo, Z(p.tab.titleToolbar), 1)
      ], 10, Fo)
    ], 8, Vo)), [
      [Tt, !p.tab.isHiddenMobile]
    ]);
  }
});
const Ro = ["href", "target", "rel", "data-event", "onClick"], Wo = ["data-event", "onClick"], xn = /* @__PURE__ */ Q({
  __name: "ToolbarContextual",
  props: {
    items: {},
    isOpen: { type: Boolean, default: !1 },
    showActive: { type: Boolean, default: !1 },
    isUp: { type: Boolean, default: !1 },
    activeItem: {}
  },
  emits: ["updated"],
  setup(a, { emit: e }) {
    const n = a, t = z(() => n.showActive ? n.items : n.items.filter((o) => {
      var i;
      return o.label !== ((i = n.activeItem) == null ? void 0 : i.label);
    }));
    return (o, i) => (v(), x("ul", {
      class: X(["ToolbarContextual", {
        "ToolbarContextual--open": o.isOpen,
        "ToolbarContextual--up": o.isUp
      }])
    }, [
      (v(!0), x(re, null, fe(t.value, (s) => (v(), x("li", {
        key: s.label,
        class: "ToolbarContextual__option"
      }, [
        s.href ? (v(), x("a", {
          key: 0,
          href: s.href,
          target: s.target || "_self",
          rel: s.rel || "",
          class: "ToolbarContextual__btn",
          "data-event": o.$ga.getDataEventValue("toolbarContextual", s.label),
          onClick: (u) => e("updated", s)
        }, [
          (v(), W(ie(L(Fe)(s.icon)), { size: "md" })),
          w("span", null, Z(s.label), 1)
        ], 8, Ro)) : (v(), x("button", {
          key: 1,
          class: "ToolbarContextual__btn",
          "data-event": o.$ga.getDataEventValue("toolbarContextual", s.label),
          onClick: (u) => e("updated", s)
        }, [
          (v(), W(ie(L(Fe)(s.icon)), { size: "md" })),
          w("span", null, Z(s.label), 1)
        ], 8, Wo))
      ]))), 128))
    ], 2));
  }
});
const jo = { class: "ToolbarDownload" }, Yo = ["data-event", "href", "target"], Ho = { class: "ToolbarDownload__wrapper" }, Uo = /* @__PURE__ */ w("p", { class: "ToolbarDownload__text" }, "PDF", -1), Xo = { class: "ToolbarDownload__format" }, Jo = {
  key: 0,
  class: "TooltipD TooltipD--bottom TooltipD--right"
}, qo = /* @__PURE__ */ Q({
  __name: "ToolbarDownload",
  setup(a) {
    const e = I(!1), n = I(!1), t = I(null), o = V("downloadItems"), i = V("emitter"), s = z(() => o.map((h) => ({
      key: h.key,
      label: h.label,
      icon: "DownloadIcon",
      href: h.href,
      target: h.target,
      rel: "noopener noreferrer"
    }))), u = z(() => s.value.length === 0 ? {
      key: "",
      label: "",
      icon: "DownloadIcon",
      href: "",
      target: "_self"
    } : s.value.find(
      (p) => p.label.toLowerCase() === "pdf"
    ) || s.value[0]), l = (h) => {
      i.emit("article-download", h);
    }, r = () => {
      n.value = !0, e.value = !e.value;
    }, c = () => {
      e.value = !1;
    }, d = () => {
      n.value = !1;
    }, g = (h) => {
      e.value = !1, l(h);
    };
    return (h, p) => (v(), x("li", jo, [
      w("a", {
        ref_key: "linkDownload",
        ref: t,
        "data-event": h.$ga.getDataEventValue("Download", "a", u.value.label),
        href: u.value.href,
        class: "ToolbarDownload__action",
        rel: "noopener noreferrer",
        target: u.value.target,
        onClick: p[0] || (p[0] = (O) => l(u.value))
      }, [
        w("div", Ho, [
          R(L(ln), {
            fill: "white",
            size: "lg"
          })
        ]),
        Uo
      ], 8, Yo),
      R(L(cn), { onTrigger: c }, {
        default: le(() => [
          w("div", Xo, [
            w("button", {
              class: X(["ToolbarDownload__format__trigger", {
                "ToolbarDownload__format__trigger--open": e.value
              }]),
              onClick: r,
              onMouseleave: d
            }, [
              !n.value && !e.value ? (v(), x("p", Jo, " Download other format ")) : N("", !0),
              R(L(Hn), { size: "md" })
            ], 34),
            R(xn, {
              items: s.value,
              "is-open": e.value,
              "active-item": u.value,
              onUpdated: g
            }, null, 8, ["items", "is-open", "active-item"])
          ])
        ]),
        _: 1
      })
    ]));
  }
});
const Go = {
  key: 1,
  class: "ToolbarItem ToolbarItem--more"
}, Zo = ["data-event"], Ko = /* @__PURE__ */ w("span", { class: "ToolbarItem__text" }, "More", -1), Qo = /* @__PURE__ */ Q({
  __name: "Toolbar",
  emits: ["download"],
  setup(a, { emit: e }) {
    H.registerPlugin(Be);
    const n = V("toolbar"), t = V("tabs"), o = V("isDesktopApp"), i = V("isResizingBody"), s = V("activeTab"), u = V("isOpenMoreOptions"), l = V("isOpenSidePanel"), r = V("goToTab"), c = V("hasDownload"), d = I(t.value.length - 1), g = I([]), h = I(!0), p = () => {
      u.value = !u.value;
    }, O = () => {
      t.value.forEach((k) => {
        k.isHiddenMobile = !1;
      }), d.value = t.value.length - 1, h.value = !0, g.value = [];
    }, b = () => {
      if (!n.value || t.value.length - g.value.length <= 1)
        return;
      n.value.scrollWidth > n.value.clientWidth ? (t.value[d.value].isHiddenMobile = !0, g.value.push(t.value[d.value]), d.value--, setTimeout(() => {
        b();
      }, 0)) : setTimeout(() => {
        h.value = g.value.length > 0, H.set(n.value, { opacity: 1 });
      }, 0);
    }, f = () => {
      O(), Ie(() => {
        o.value || b();
      });
    }, E = z(() => g.value.map((B, D) => ({
      key: "showMoreItem-" + D,
      label: B.titleToolbar,
      icon: B.icon,
      href: B.href,
      target: B.target,
      rel: B.rel
    })).reverse()), m = (k) => {
      if (k.href)
        window.open(k.href, k.target || "_blank");
      else {
        const B = t.value.find((D) => D.titleToolbar === k.label);
        B && (s.value = B, r.value());
      }
      A();
    }, A = () => {
      u.value = !1;
    }, C = () => {
      Be.create({
        trigger: "body",
        start: "top -11",
        end: "top -11",
        markers: !1,
        scrub: !0,
        onEnter: () => {
          parseInt(
            document.body.getAttribute("data-scroll-top") || "0"
          ) > 10 && window.scrollY === 0 || o.value && H.to(n.value, {
            top: 96,
            duration: 0.3,
            ease: "power2.out"
          });
        },
        onEnterBack: () => {
          parseInt(
            document.body.getAttribute("data-scroll-top") || "0"
          ) > 10 && window.scrollY === 0 || o.value && H.to(n.value, {
            top: 96 + 48,
            duration: 0.3,
            ease: "power2.out"
          });
        }
      });
    };
    return K(
      () => t.value,
      () => {
        setTimeout(() => {
          o.value || f();
        }, 1);
      }
    ), K(
      () => i.value,
      () => {
        f();
      }
    ), pe(() => {
      f(), C();
    }), (k, B) => (v(), x("nav", {
      ref_key: "toolbar",
      ref: n,
      class: "Toolbar"
    }, [
      w("ul", {
        class: X(["Toolbar__list", { "Toolbar__list--withSidepanel": L(l) }])
      }, [
        L(c) ? (v(), W(qo, { key: 0 })) : N("", !0),
        (v(!0), x(re, null, fe(L(t), (D) => (v(), W(No, {
          key: D.targetId,
          tab: D
        }, null, 8, ["tab"]))), 128)),
        h.value && L(t).length > 2 ? (v(), x("li", Go, [
          w("a", {
            "data-event": k.$ga.getDataEventValue("InfoDrawer", "a", "moreOptions"),
            class: "ToolbarItem__action",
            onClick: p
          }, [
            (v(), W(ie(L(Fe)("MoreOptionsVerticalIcon")), { size: "lg" })),
            Ko
          ], 8, Zo),
          R(L(cn), { onTrigger: A }, {
            default: le(() => [
              R(xn, {
                items: E.value,
                "is-open": L(u),
                "show-active": !0,
                "is-up": !0,
                onUpdated: m
              }, null, 8, ["items", "is-open"])
            ]),
            _: 1
          })
        ])) : N("", !0)
      ], 2)
    ], 512));
  }
});
const es = { class: "SidePanelID__close" }, ts = {
  key: 0,
  class: "SidePanelID__title"
}, ns = ["id"], is = ["id"], os = /* @__PURE__ */ Q({
  __name: "SidePanelID",
  setup(a) {
    const e = rn, n = V("sidePanel"), t = V("isOpenSidePanel"), o = V("closeSidePanel"), i = V("activeTab"), s = V("isClickingOnTab"), u = V("isChangingTab"), l = V("tabs"), r = V("isDesktopApp"), c = V("animations"), d = V("isOpenMoreOptions"), g = V("heading"), h = I(null), { isSwiping: p, direction: O } = sn(h), b = I(!1), f = I(null), { hasScrollbar: E } = Nt(f), m = Ct(), A = (D) => {
      var y;
      return r.value ? !0 : ((y = i.value) == null ? void 0 : y.targetId) === D;
    }, C = () => {
      o(), setTimeout(() => {
        b.value = !1;
      }, m);
    }, k = () => {
      const D = f.value;
      if (D)
        if (t.value) {
          if (!i.value)
            return;
          const y = document.getElementById(i.value.targetId);
          if (!f.value || !y) {
            y || console.warn(
              `SidePanel content for tab ${i.value.targetId} not found`
            );
            return;
          }
          D.scrollTo({
            top: y.offsetTop
          }), setTimeout(() => {
            s.value = !1;
          }, m), D.style.scrollBehavior = "smooth";
        } else
          setTimeout(() => {
            D.style.scrollBehavior = "auto", D.scrollTo({
              top: 0
            });
          }, m);
    };
    K(
      () => t.value,
      () => {
        k();
      }
    ), K(p, () => {
      O.value === "up" ? (b.value = !0, c.toogleExpandSP(!0)) : O.value === "down" && (C(), d.value = !1);
    });
    const { activeId: B } = Hi(
      l,
      "targetId",
      t,
      f,
      -54
    );
    return K(B, () => {
      if (B.value && !u.value && r.value) {
        const D = l.value.find((y) => y.targetId === B.value);
        D && (i.value = D);
      }
    }), pe(() => {
      k();
    }), (D, y) => {
      var _;
      return Le((v(), x("div", {
        ref_key: "sidePanel",
        ref: n,
        class: "SidePanelID"
      }, [
        w("div", es, [
          R(L(Ae), {
            color: "Black",
            size: "Medium",
            label: "Close the panel",
            "data-event": D.$ga.getDataEventValue("SidePanelID", "button", "close"),
            icon: "Close",
            onClick: C
          }, null, 8, ["data-event"])
        ]),
        w("div", {
          ref_key: "headerMobile",
          ref: h,
          class: "SidePanelID__headerMobile"
        }, [
          L(i) ? (v(), x("p", ts, [
            (v(), W(ie(L(Fe)(L(i).icon)), {
              fill: "black",
              size: "md"
            })),
            Ce(" " + Z(L(i).title), 1)
          ])) : N("", !0),
          R(L(Ae), {
            color: "Black",
            size: "Small",
            label: "Close the panel",
            "data-event": D.$ga.getDataEventValue("SidePanelID", "button", "close"),
            icon: "Close",
            onClick: L(o)
          }, null, 8, ["data-event", "onClick"])
        ], 512),
        w("div", {
          ref_key: "body",
          ref: f,
          class: X(`SidePanelID__body SidePanelID__body--${(_ = L(i)) == null ? void 0 : _.targetId}`)
        }, [
          (v(!0), x(re, null, fe(L(l), (T) => {
            var P;
            return v(), x(re, {
              key: T.targetId
            }, [
              (P = T.href) != null && P.length ? N("", !0) : Le((v(), x("div", {
                key: 0,
                id: T.targetId,
                class: "SidePanelID__section"
              }, [
                w("div", {
                  class: X(["SidePanelID__wrapper", { "SidePanelID__wrapper--scrollbar": L(E) }])
                }, [
                  L(r) ? (v(), W(ie(L(g)), {
                    key: 0,
                    class: "SidePanelID__title"
                  }, {
                    default: le(() => [
                      (v(), W(ie(L(Fe)(T.icon)), {
                        fill: "black",
                        size: "lg"
                      })),
                      Ce(" " + Z(T.title), 1)
                    ]),
                    _: 2
                  }, 1024)) : N("", !0),
                  w("div", {
                    class: "SidePanelID__content",
                    id: `${T.targetId}-content`
                  }, [
                    on(D.$slots, T.targetId)
                  ], 8, is)
                ], 2)
              ], 8, ns)), [
                [Tt, A(T.targetId)]
              ])
            ], 64);
          }), 128))
        ], 2)
      ])), [
        [
          L(e),
          L(t),
          void 0,
          { backDelayInfoDrawer: !0 }
        ]
      ]);
    };
  }
});
H.registerPlugin(U);
const G = {
  easeIn: "power1.in",
  easeOut: "power1.out",
  easeInOut: "power1.in.out",
  toolbarOffset: 96,
  desktopBreakpoint: 1024
}, ss = (a, e, n, t, o, i, s) => {
  const u = Un(), l = I(!1), r = I(!1), c = () => window.innerWidth > G.desktopBreakpoint, d = () => i.value ? 0 : window.innerHeight / 3, g = () => i.value ? 1 : 0, h = () => {
    const _ = o.value.getBoundingClientRect();
    return {
      width: _.width,
      rightPosition: window.innerWidth - _.left
    };
  }, p = (y, _ = 1) => y ? 0 : u * _, O = (y = !1) => {
    l.value = y, c() ? E(y) : A(y), k(y);
  }, b = (y = !1) => {
    l.value = y, c() ? m(y) : C(y), B(y);
  }, f = () => {
    if (!c())
      return;
    const { width: y } = h(), _ = p(!1, 1);
    H.set(e.value, { x: y }), H.to(e.value, {
      y: d(),
      opacity: g(),
      duration: _,
      ease: "linear",
      onStart: () => {
        var T;
        i.value && ((T = e.value) == null || T.classList.remove("Toolbar--invisible"));
      },
      onComplete: () => {
        var T;
        !i.value && !s.value && ((T = e.value) == null || T.classList.add("Toolbar--invisible"));
      }
    });
  }, E = (y = !1) => {
    var M;
    (M = e.value) == null || M.classList.remove("Toolbar--invisible");
    const _ = p(y), { width: T, rightPosition: P } = h(), $ = H.timeline({
      onComplete() {
        l.value = !1;
      }
    });
    i.value ? $.to(n.value, {
      x: T + G.toolbarOffset,
      duration: _ * 0.4,
      ease: G.easeIn
    }).to([e.value, n.value], {
      x: (S) => S === 0 ? -G.toolbarOffset : 0,
      duration: _ * 0.6,
      ease: G.easeOut
    }) : (H.set(e.value, {
      y: 0,
      opacity: 1,
      x: P + G.toolbarOffset
    }), $.to([e.value, n.value], {
      x: (S) => S === 0 ? -G.toolbarOffset : 0,
      duration: _,
      ease: G.easeIn
    }));
  }, m = (y = !1) => {
    const _ = p(y), { width: T, rightPosition: P } = h(), $ = H.timeline({
      onComplete() {
        l.value = !1;
      }
    });
    i.value ? $.to([n.value, e.value], {
      x: (M) => M === 0 ? T + G.toolbarOffset : T,
      duration: _ * 0.6,
      ease: G.easeIn
    }).to(n.value, {
      x: P,
      duration: _ * 0.4,
      ease: G.easeOut
    }) : $.to([n.value, e.value], {
      x: (M) => M === 0 ? P + G.toolbarOffset : P,
      duration: _,
      ease: G.easeIn,
      onComplete: () => {
        H.set(e.value, {
          y: d()
        });
      }
    });
  }, A = (y = !1) => {
    const _ = p(y);
    H.timeline({
      onComplete() {
        l.value = !1;
      }
    }).to(e.value, {
      bottom: -120,
      x: 0,
      duration: _ * 0.3,
      ease: G.easeInOut
    }).to(n.value, {
      bottom: 0,
      duration: _ * 0.7,
      ease: G.easeOut
    });
  }, C = (y = !1) => {
    const _ = p(y);
    H.timeline({
      onComplete() {
        l.value = !1;
      }
    }).to(n.value, {
      bottom: "-100%",
      duration: _,
      ease: G.easeOut
    }).to(
      e.value,
      {
        bottom: 0,
        duration: _ * 0.5,
        ease: G.easeInOut
      },
      "-=50%"
    );
  }, k = (y = !1) => {
    const _ = p(y, 0.8);
    H.to(t.value, {
      opacity: 1,
      pointerEvents: "all",
      duration: _,
      delay: _,
      ease: G.easeOut
    });
  }, B = (y = !1) => {
    const _ = p(y, 0.6);
    H.to(t.value, {
      opacity: 0,
      pointerEvents: "none",
      duration: _,
      ease: G.easeInOut
    });
  }, D = () => {
    n.value && n.value.removeAttribute("style"), e.value && e.value.removeAttribute("style");
  };
  return pe(() => {
    b(!0), Ie(() => {
      var y, _, T;
      H.set(a.value, { opacity: "1" }), c() ? i.value ? (y = e.value) == null || y.classList.remove("Toolbar--invisible") : (_ = e.value) == null || _.classList.add("Toolbar--invisible") : (T = e.value) == null || T.classList.remove("Toolbar--invisible");
    });
  }), {
    showSidePanel: O,
    closeSidePanel: b,
    toogleOnlyToolbarInDesktop: f,
    isSidePanelTransitioningToOpen: r,
    clearPropsSPT: D,
    isTransitioning: l
  };
}, Ps = /* @__PURE__ */ Q({
  __name: "InfoDrawer",
  props: {
    showToolbar: { type: Boolean, default: !1 },
    downloadItems: { default: () => new Array() },
    forceOpenTab: { type: Boolean, default: !1 },
    tabToOpen: {},
    hasOutline: { type: Boolean, default: !0 },
    hasMetrics: { type: Boolean, default: !0 },
    hasShare: { type: Boolean, default: !0 },
    hasFigures: { type: Boolean, default: !1 },
    hasSupplementaryMaterial: { type: Boolean, default: !1 },
    hasCite: { type: Boolean, default: !0 },
    hasDownload: { type: Boolean, default: !0 },
    fair2DataPortalURL: {},
    heading: { default: "h3" }
  },
  emits: ["download", "close-side-panel", "go-to-id", "update:is-open-side-panel"],
  setup(a, { emit: e }) {
    const n = a, t = V("emitter"), o = V("isDesktopApp"), i = V("isResizingBody"), s = I(null), u = I(null), l = I(null), r = I(!1), c = I(null), d = I(null), g = I(!1), h = ss(
      l,
      s,
      u,
      c,
      d,
      g,
      r
    ), p = I(null), O = I(!1), b = I(!1), f = I(1441), E = I(!1), m = I(() => {
    }), A = I(!1), C = Ct(), k = () => {
      if (E.value)
        return;
      h.closeSidePanel();
      const T = window.location.hash;
      Xn(T) && (window.location.hash = ""), r.value = !1, setTimeout(() => {
        p.value = null, e("close-side-panel");
      }, C);
    }, B = I(Ut(n));
    te("toolbar", s), te("sidePanel", u), te("isOpenSidePanel", r), te("animations", h), te("activeTab", p), te("closeSidePanel", k), te("isClickingOnTab", O), te("tabs", B), te("isChangingTab", b), te("isOpenMoreOptions", A), te("hasDownload", n.hasDownload), te("downloadItems", n.downloadItems), te("heading", n.heading), te("goToTab", m);
    const D = (T) => {
      e("download", T);
    };
    K(
      () => [
        n.hasSupplementaryMaterial,
        n.hasFigures,
        n.hasCite,
        n.hasOutline,
        n.hasShare,
        n.hasMetrics
      ],
      () => {
        B.value = Ut(n);
      }
    ), K(
      () => n.showToolbar,
      () => {
        g.value = n.showToolbar, r.value || h.toogleOnlyToolbarInDesktop();
      }
    ), K(
      () => n.forceOpenTab,
      () => {
        if (n.tabToOpen) {
          p.value = un(B.value, n.tabToOpen);
          const T = n.showToolbar ? 600 : 0;
          setTimeout(() => {
            m.value();
          }, T);
        }
      }
    ), K(
      () => o.value,
      () => {
        h.closeSidePanel(!0), r.value && h.showSidePanel(!0);
      }
    ), K(
      () => i.value,
      () => {
        f.value = window.innerWidth, h.clearPropsSPT(), r.value ? h.showSidePanel(!0) : h.closeSidePanel(!0);
      }
    ), K(
      () => r.value,
      () => {
        e("update:is-open-side-panel", r.value), t.emit("is-open-side-panel", r.value), r.value && (E.value = !0, setTimeout(() => {
          E.value = !1;
        }, C));
      }
    );
    const y = (T) => {
      const P = o.value ? 0 : C;
      o.value || k(), setTimeout(() => {
        e("go-to-id", T);
      }, P);
    }, _ = () => {
      o.value || k();
    };
    return pe(() => {
      f.value = window.innerWidth, t.on("go-to-id", y), t.on("close-info-drawer", _), g.value = n.showToolbar, h.toogleOnlyToolbarInDesktop();
    }), Dn(() => {
      t.off("go-to-id", y), t.off("close-info-drawer", _);
    }), (T, P) => (v(), x("div", {
      ref_key: "infoDrawer",
      ref: l,
      class: "InfoDrawer"
    }, [
      w("button", {
        ref_key: "overlay",
        ref: c,
        "aria-label": "Close panel",
        class: "InfoDrawer__overlay",
        onClick: k
      }, null, 512),
      R(Qo, { onDownload: D }),
      R(os, null, $n({ _: 2 }, [
        fe(B.value, ($) => ({
          name: $.targetId,
          fn: le(() => [
            on(T.$slots, $.targetId, {
              key: $.targetId
            })
          ])
        }))
      ]), 1024),
      w("div", {
        ref_key: "middleStateEl",
        ref: d,
        class: "InfoDrawer__refMiddle"
      }, null, 512)
    ], 512));
  }
});
export {
  Gn as B,
  si as P,
  Is as _,
  Jt as a,
  ks as b,
  Vi as c,
  xs as d,
  Ts as e,
  Ls as f,
  ao as g,
  Cs as h,
  Ps as i,
  xn as j,
  Hi as k,
  Ui as l,
  Zn as m,
  Nt as u
};
